import { FC, SVGProps } from "react";

export interface IIconProps extends SVGProps<SVGSVGElement> {
	size?: string | number;
}

export type CustomIconType = FC<IIconProps>;

export const DeleteIcon: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M1.91797 3.42H2.70703M10.0777 3.42H9.29297M9.29297 3.42L8.98229 9.97592C8.97471 10.1359 8.84279 10.2617 8.68263 10.2617H3.31737C3.15721 10.2617 3.02529 10.1359 3.01771 9.97592L2.70703 3.42M9.29297 3.42H8.2M2.70703 3.42H3.8M3.8 3.42V2.03828C3.8 1.8726 3.93431 1.73828 4.1 1.73828H7.9C8.06568 1.73828 8.2 1.8726 8.2 2.03828V3.42M3.8 3.42H8.2"
				stroke="currentColor"
				strokeWidth="0.84"
				strokeLinecap="round"
			/>
		</svg>
	);
};

export const MenuFiscal: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<text x="0" y="8" fontFamily="Arial" fontSize="8" fill="black">
				M
			</text>
			<text x="7" y="8" fontFamily="Arial" fontSize="8" fill="black">
				F
			</text>
		</svg>
	);
};

export const AddIcon: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path d="M6.0009 6.00092H2.5M6.0009 6.00092H9.5M6.0009 6.00092V2.5M6.0009 6.00092V9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
		</svg>
	);
};

export const CheckMark: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path d="M1.67822 6.45838L4.20005 8.98L10.3146 2.86536" stroke="currentColor" strokeLinecap="round" />
		</svg>
	);
};

export const IconFilter: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M10.6594 10.0137L7.61602 6.97031C8.08828 6.35977 8.34375 5.61328 8.34375 4.82812C8.34375 3.88828 7.97695 3.00703 7.31367 2.34258C6.65039 1.67812 5.7668 1.3125 4.82812 1.3125C3.88945 1.3125 3.00586 1.6793 2.34258 2.34258C1.67812 3.00586 1.3125 3.88828 1.3125 4.82812C1.3125 5.7668 1.6793 6.65039 2.34258 7.31367C3.00586 7.97812 3.88828 8.34375 4.82812 8.34375C5.61328 8.34375 6.35859 8.08828 6.96914 7.61719L10.0125 10.6594C10.0214 10.6683 10.032 10.6754 10.0437 10.6802C10.0553 10.6851 10.0678 10.6875 10.0805 10.6875C10.0931 10.6875 10.1056 10.6851 10.1173 10.6802C10.1289 10.6754 10.1395 10.6683 10.1484 10.6594L10.6594 10.1496C10.6683 10.1407 10.6754 10.1301 10.6802 10.1184C10.6851 10.1068 10.6875 10.0943 10.6875 10.0816C10.6875 10.069 10.6851 10.0565 10.6802 10.0449C10.6754 10.0332 10.6683 10.0226 10.6594 10.0137ZM6.68438 6.68438C6.1875 7.18008 5.52891 7.45312 4.82812 7.45312C4.12734 7.45312 3.46875 7.18008 2.97188 6.68438C2.47617 6.1875 2.20312 5.52891 2.20312 4.82812C2.20312 4.12734 2.47617 3.46758 2.97188 2.97188C3.46875 2.47617 4.12734 2.20312 4.82812 2.20312C5.52891 2.20312 6.18867 2.475 6.68438 2.97188C7.18008 3.46875 7.45312 4.12734 7.45312 4.82812C7.45312 5.52891 7.18008 6.18867 6.68438 6.68438Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const Close: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M2.54983 2.54993L5.99986 5.99996M9.44589 9.44599L5.99986 5.99996M5.99986 5.99996L9.4499 2.54993M5.99986 5.99996L2.5498 9.45003"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || "1.1"}
				strokeLinecap="round"
			/>
		</svg>
	);
};

export const MaisOpcoes: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M6 6.5C6.27614 6.5 6.5 6.27614 6.5 6C6.5 5.72386 6.27614 5.5 6 5.5C5.72386 5.5 5.5 5.72386 5.5 6C5.5 6.27614 5.72386 6.5 6 6.5Z"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 10C6.27614 10 6.5 9.77614 6.5 9.5C6.5 9.22386 6.27614 9 6 9C5.72386 9 5.5 9.22386 5.5 9.5C5.5 9.77614 5.72386 10 6 10Z"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 3C6.27614 3 6.5 2.77614 6.5 2.5C6.5 2.22386 6.27614 2 6 2C5.72386 2 5.5 2.22386 5.5 2.5C5.5 2.77614 5.72386 3 6 3Z"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const IconCadastros: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<g>
				<path d="M9.75 3.75H15.75" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M9.75 6.75H13.5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M9.75 11.25H15.75" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M9.75 14.25H13.5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M6 3H3C2.58579 3 2.25 3.33579 2.25 3.75V6.75C2.25 7.16421 2.58579 7.5 3 7.5H6C6.41421 7.5 6.75 7.16421 6.75 6.75V3.75C6.75 3.33579 6.41421 3 6 3Z"
					stroke="currentColor"
					strokeWidth="1"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6 10.5H3C2.58579 10.5 2.25 10.8358 2.25 11.25V14.25C2.25 14.6642 2.58579 15 3 15H6C6.41421 15 6.75 14.6642 6.75 14.25V11.25C6.75 10.8358 6.41421 10.5 6 10.5Z"
					stroke="currentColor"
					strokeWidth="1"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</svg>
	);
};

export const IconCliente: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M15 15.795V14.295C15 13.4994 14.6839 12.7363 14.1213 12.1737C13.5587 11.6111 12.7956 11.295 12 11.295H6C5.20435 11.295 4.44129 11.6111 3.87868 12.1737C3.31607 12.7363 3 13.4994 3 14.295V15.795"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9 8.29504C10.6569 8.29504 12 6.9519 12 5.29504C12 3.63819 10.6569 2.29504 9 2.29504C7.34315 2.29504 6 3.63819 6 5.29504C6 6.9519 7.34315 8.29504 9 8.29504Z"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const IconColaborador: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M2.99683 16.83V15.3013C2.99683 13.0922 4.78769 11.3013 6.99683 11.3013H11.003C13.2121 11.3013 15.003 13.0922 15.003 15.3013V16.8262"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
			/>
			<path
				d="M12.4001 5.66611C12.4001 7.5441 10.8781 9.06611 9.0001 9.06611C7.12211 9.06611 5.6001 7.5441 5.6001 5.66611C5.6001 3.78812 7.12211 2.26611 9.0001 2.26611C10.8781 2.26611 12.4001 3.78812 12.4001 5.66611Z"
				stroke="currentColor"
				strokeWidth="1"
			/>
			<path
				d="M5.71631 4.38943C5.71631 4.58273 5.87301 4.73943 6.06631 4.73943H11.8663C12.0596 4.73943 12.2163 4.58273 12.2163 4.38943C12.2163 2.81542 10.9403 1.53943 9.36631 1.53943H8.56631C6.99229 1.53943 5.71631 2.81542 5.71631 4.38943Z"
				fill="var(--fill-color)"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.74014 0.820068C8.54684 0.820068 8.39014 0.976768 8.39014 1.17006V4.92006C8.39014 5.11336 8.54684 5.27006 8.74014 5.27006H9.30802C9.50132 5.27006 9.65802 5.11336 9.65802 4.92006V1.17006C9.65802 0.976768 9.50132 0.820068 9.30802 0.820068H8.74014Z"
				fill="var(--fill-color)"
				stroke="currentColor"
				strokeWidth=".8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.36201 5.41616H12.637C12.9753 5.41616 13.2495 5.14193 13.2495 4.80366C13.2495 4.46538 12.9753 4.19116 12.637 4.19116H5.36201C5.02373 4.19116 4.74951 4.46538 4.74951 4.80366C4.74951 5.14193 5.02373 5.41616 5.36201 5.41616Z"
				fill="var(--fill-color)"
				stroke="currentColor"
				strokeWidth=".8"
			/>
			<path
				d="M6.7499 11.3045C6.5566 11.3045 6.3999 11.4612 6.3999 11.6545V16.3161C6.3999 16.5094 6.5566 16.6661 6.7499 16.6661H7.2749C7.4682 16.6661 7.6249 16.5094 7.6249 16.3161V11.6545C7.6249 11.4612 7.4682 11.3045 7.2749 11.3045H6.7499Z"
				stroke="currentColor"
				strokeWidth=".8"
				strokeLinejoin="round"
			/>
			<path
				d="M10.4999 11.3045C10.3066 11.3045 10.1499 11.4612 10.1499 11.6545V16.3162C10.1499 16.5095 10.3066 16.6662 10.4999 16.6662H11.0249C11.2182 16.6662 11.3749 16.5095 11.3749 16.3162V11.6545C11.3749 11.4612 11.2182 11.3045 11.0249 11.3045H10.4999Z"
				stroke="currentColor"
				strokeWidth=".8"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const IconCompra: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...newProps}>
			<path d="M10.875 6.29875L4.125 2.40625" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M9.49621 14.8338L8.25 15.546C8.02197 15.6776 7.76331 15.7469 7.5 15.7469C7.23669 15.7469 6.97803 15.6776 6.75 15.546L1.5 12.546C1.2722 12.4144 1.08299 12.2253 0.951346 11.9976C0.819707 11.7699 0.75027 11.5115 0.75 11.2485V5.24846C0.75027 4.98542 0.819707 4.72707 0.951346 4.49933C1.08299 4.2716 1.2722 4.08248 1.5 3.95096L6.75 0.950962C6.97803 0.819309 7.23669 0.75 7.5 0.75C7.76331 0.75 8.02197 0.819309 8.25 0.950962L13.5 3.95096C13.7278 4.08248 13.917 4.2716 14.0487 4.49933C14.1803 4.72707 14.2497 4.98542 14.25 5.24846V9.4241"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M0.952148 4.46875L7.49965 8.25625L14.0471 4.46875" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M7.5 15.808V8.24805" strokeLinecap="round" strokeLinejoin="round" />
			<circle cx="13.5" cy="13.5" r="4.15" />
			<path d="M13.5004 11.7861V13.5004M11.7861 13.5004H13.5004M13.5004 15.2147V13.5004M15.2147 13.5004H13.5004" strokeLinecap="round" />
		</svg>
	);
};

export const IconConfiguracao: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M7.75702 2.955C7.82452 2.5485 8.17702 2.25 8.58952 2.25H9.40927C9.82177 2.25 10.1743 2.5485 10.2418 2.955L10.3535 3.6255C10.406 3.9435 10.6415 4.1985 10.9385 4.323C11.237 4.446 11.5798 4.4295 11.8423 4.242L12.395 3.84675C12.5576 3.73054 12.7561 3.6758 12.9553 3.69228C13.1544 3.70877 13.3413 3.7954 13.4825 3.93675L14.0623 4.51725C14.3548 4.809 14.3923 5.26875 14.1523 5.60475L13.757 6.1575C13.5695 6.42 13.553 6.762 13.6768 7.0605C13.8005 7.35825 14.0555 7.593 14.3743 7.6455L15.044 7.758C15.4513 7.8255 15.749 8.178 15.749 8.58975V9.41025C15.749 9.82275 15.4513 10.1752 15.044 10.2427L14.3743 10.3545C14.0555 10.407 13.8005 10.6418 13.6768 10.9395C13.553 11.238 13.5695 11.58 13.757 11.8425L14.1523 12.396C14.3923 12.7312 14.354 13.191 14.0623 13.4835L13.4818 14.0632C13.3406 14.2044 13.1539 14.2909 12.9549 14.3074C12.7559 14.3239 12.5575 14.2693 12.395 14.1533L11.8415 13.758C11.579 13.5705 11.237 13.554 10.9393 13.6777C10.6415 13.8015 10.4068 14.0565 10.3535 14.3745L10.2418 15.045C10.1743 15.4515 9.82177 15.75 9.40927 15.75H8.58877C8.17627 15.75 7.82452 15.4515 7.75627 15.045L7.64527 14.3745C7.59202 14.0565 7.35727 13.8015 7.05952 13.677C6.76102 13.554 6.41902 13.5705 6.15652 13.758L5.60302 14.1533C5.26777 14.3933 4.80802 14.355 4.51552 14.0632L3.93577 13.4827C3.79442 13.3415 3.70779 13.1547 3.69131 12.9555C3.67483 12.7564 3.72956 12.5578 3.84577 12.3953L4.24102 11.8425C4.42852 11.58 4.44577 11.238 4.32202 10.9395C4.19827 10.6418 3.94327 10.407 3.62452 10.3545L2.95402 10.242C2.54752 10.1745 2.24902 9.822 2.24902 9.41025V8.58975C2.24902 8.17725 2.54752 7.82475 2.95402 7.75725L3.62452 7.6455C3.94252 7.593 4.19827 7.35825 4.32202 7.0605C4.44577 6.762 4.42927 6.42 4.24177 6.1575L3.84652 5.604C3.73031 5.44143 3.67558 5.24289 3.69206 5.04374C3.70854 4.84459 3.79517 4.65775 3.93652 4.5165L4.51627 3.93675C4.65753 3.7954 4.84436 3.70877 5.04352 3.69228C5.24267 3.6758 5.44121 3.73054 5.60377 3.84675L6.15652 4.242C6.41902 4.4295 6.76177 4.446 7.05952 4.32225C7.35727 4.1985 7.59202 3.9435 7.64452 3.6255L7.75702 2.955V2.955Z"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.25 9C11.25 9.59674 11.0129 10.169 10.591 10.591C10.169 11.0129 9.59674 11.25 9 11.25C8.40326 11.25 7.83097 11.0129 7.40901 10.591C6.98705 10.169 6.75 9.59674 6.75 9C6.75 8.40326 6.98705 7.83097 7.40901 7.40901C7.83097 6.98705 8.40326 6.75 9 6.75C9.59674 6.75 10.169 6.98705 10.591 7.40901C11.0129 7.83097 11.25 8.40326 11.25 9V9Z"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const IconConsignado: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M10.5 1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V6L10.5 1.5Z"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.5 1.5L10.7475 1.25251C10.6474 1.15241 10.4968 1.12247 10.3661 1.17664C10.2353 1.23082 10.15 1.35844 10.15 1.5H10.5ZM15 6V6.35C15.1416 6.35 15.2692 6.26473 15.3234 6.13394C15.3775 6.00315 15.3476 5.85261 15.2475 5.75251L15 6ZM10.15 1.5V5.3H10.85V1.5H10.15ZM11.2 6.35H15V5.65H11.2V6.35ZM10.2525 1.74749L14.7525 6.24749L15.2475 5.75251L10.7475 1.25251L10.2525 1.74749ZM10.15 5.3C10.15 5.8799 10.6201 6.35 11.2 6.35V5.65C11.0067 5.65 10.85 5.4933 10.85 5.3H10.15Z"
				fill="currentColor"
			/>
			<path
				d="M5.84961 9L7.34961 7.5M7.34961 7.5L8.84961 9M7.34961 7.5V12M12.1496 12L10.6496 13.5M10.6496 13.5L9.14961 12M10.6496 13.5V9"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const IconDespesas: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<g>
				<path d="M1.05015 0.349976C0.663553 0.349976 0.350156 0.663366 0.350146 1.04996L0.350098 2.95H0.95C2.05457 2.95 2.95 2.05457 2.95 0.95V0.349976H1.05015Z" fill="currentColor" />
				<path d="M0.350098 8.3L0.350146 10.2C0.350156 10.5866 0.663553 10.9 1.05015 10.9H2.95V10.3C2.95 9.19543 2.05457 8.3 0.95 8.3H0.350098Z" fill="currentColor" />
				<path d="M17.6502 1.04998C17.6502 0.663376 17.3368 0.349976 16.9502 0.349976H15.05V0.95C15.05 2.05457 15.9454 2.95 17.05 2.95H17.6502V1.04998Z" fill="currentColor" />
				<path
					d="M0.350098 2.95L9.76622e-05 2.94999V2.95H0.350098ZM0.350098 8.3L9.76621e-05 8.3L9.76623e-05 8.30001L0.350098 8.3ZM0.700098 2.95001L0.700146 1.04997L0.000145756 1.04995L9.76623e-05 2.94999L0.700098 2.95001ZM1.05015 0.699976H2.95V-2.44081e-05H1.05015V0.699976ZM0.350098 3.3H0.95V2.6H0.350098V3.3ZM3.3 0.95V0.349976H2.6V0.95H3.3ZM0.700146 10.2L0.700098 8.29999L9.76623e-05 8.30001L0.000145755 10.2L0.700146 10.2ZM0.700098 8.3V2.95H9.76622e-05V8.3H0.700098ZM16.9502 10.55H2.95V11.25H16.9502V10.55ZM2.95 10.55H1.05015V11.25H2.95V10.55ZM3.3 10.9V10.3H2.6V10.9H3.3ZM0.95 7.95H0.350098V8.65H0.95V7.95ZM2.95 0.699976H15.05V-2.44081e-05H2.95V0.699976ZM15.05 0.699976H16.9502V-2.44081e-05H15.05V0.699976ZM17.3002 1.04998V2.95H18.0002V1.04998H17.3002ZM17.3002 2.95V10.2H18.0002V2.95H17.3002ZM17.6502 2.6H17.05V3.3H17.6502V2.6ZM15.4 0.95V0.349976H14.7V0.95H15.4ZM3.3 10.3C3.3 9.00213 2.24787 7.95 0.95 7.95V8.65C1.86127 8.65 2.6 9.38873 2.6 10.3H3.3ZM0.000145755 10.2C0.000160433 10.7799 0.470256 11.25 1.05015 11.25V10.55C0.856849 10.55 0.700151 10.3933 0.700146 10.2L0.000145755 10.2ZM16.9502 11.25C17.5301 11.25 18.0002 10.7799 18.0002 10.2H17.3002C17.3002 10.3933 17.1435 10.55 16.9502 10.55V11.25ZM0.95 3.3C2.24787 3.3 3.3 2.24787 3.3 0.95H2.6C2.6 1.86127 1.86127 2.6 0.95 2.6V3.3ZM17.05 2.6C16.1387 2.6 15.4 1.86127 15.4 0.95H14.7C14.7 2.24787 15.7521 3.3 17.05 3.3V2.6ZM16.9502 0.699976C17.1435 0.699976 17.3002 0.856676 17.3002 1.04998H18.0002C18.0002 0.470077 17.5301 -2.44081e-05 16.9502 -2.44081e-05V0.699976ZM0.700146 1.04997C0.700151 0.856671 0.85685 0.699976 1.05015 0.699976V-2.44081e-05C0.470257 -2.44081e-05 0.000160433 0.470062 0.000145756 1.04995L0.700146 1.04997Z"
					fill="currentColor"
				/>
				<path d="M9 3.125V9.125" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M10.3638 4.21588H8.31832C8.06515 4.21588 7.82236 4.31645 7.64335 4.49546C7.46434 4.67447 7.36377 4.91727 7.36377 5.17043C7.36377 5.42359 7.46434 5.66638 7.64335 5.84539C7.82236 6.0244 8.06515 6.12497 8.31832 6.12497H9.68195C9.93511 6.12497 10.1779 6.22554 10.3569 6.40455C10.5359 6.58356 10.6365 6.82636 10.6365 7.07952C10.6365 7.33268 10.5359 7.57547 10.3569 7.75448C10.1779 7.9335 9.93511 8.03406 9.68195 8.03406H7.36377"
					stroke="currentColor"
					strokeWidth="1"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<g>
					<circle cx="12.375" cy="12.375" r="5.275" fill="var(--fill-color)" stroke="currentColor" strokeWidth="1" />
					<path d="M10.2314 12.375H12.3743H14.5172" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
				</g>
				<rect x="6.4" y="6.4" width="11.95" height="11.95" rx="5.975" stroke="var(--fill-color)" strokeWidth="1" />
			</g>
		</svg>
	);
};

export const IconFornecedores: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M7.70996 15.6896L8.56996 12.7896L7.70996 11.3096H10.29L9.42996 12.7896L10.29 15.6896L8.99698 16.8396L7.70996 15.6896Z"
				stroke="currentColor"
				strokeWidth={newProps.strokeWidth ?? "1"}
			/>
			<path
				d="M2.99609 16.8394V14.89V14.89C2.99609 12.9126 4.59911 11.3096 6.57652 11.3096H7.71H10.29H11.4196C13.397 11.3096 15 12.9126 15 14.89V14.89V16.8394"
				stroke="currentColor"
				strokeWidth={newProps.strokeWidth ?? "1"}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.4 5.66992C12.4 7.54791 10.878 9.06992 9 9.06992C7.12201 9.06992 5.6 7.54791 5.6 5.66992C5.6 3.79193 7.12201 2.26992 9 2.26992C10.878 2.26992 12.4 3.79193 12.4 5.66992Z"
				stroke="currentColor"
				strokeWidth={newProps.strokeWidth ?? "1"}
			/>
		</svg>
	);
};

export const IconHome: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M2.25 9L3.75 7.5M3.75 7.5L9 2.25L14.25 7.5M3.75 7.5V15C3.75 15.1989 3.82902 15.3897 3.96967 15.5303C4.11032 15.671 4.30109 15.75 4.5 15.75H6.75M14.25 7.5L15.75 9M14.25 7.5V15C14.25 15.1989 14.171 15.3897 14.0303 15.5303C13.8897 15.671 13.6989 15.75 13.5 15.75H11.25M6.75 15.75C6.94891 15.75 7.13968 15.671 7.28033 15.5303C7.42098 15.3897 7.5 15.1989 7.5 15V12C7.5 11.8011 7.57902 11.6103 7.71967 11.4697C7.86032 11.329 8.05109 11.25 8.25 11.25H9.75C9.94891 11.25 10.1397 11.329 10.2803 11.4697C10.421 11.6103 10.5 11.8011 10.5 12V15C10.5 15.1989 10.579 15.3897 10.7197 15.5303C10.8603 15.671 11.0511 15.75 11.25 15.75M6.75 15.75H11.25"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const IconListagens: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M2.87158 4.76987V3.56987C2.87158 3.18327 3.18498 2.86987 3.57158 2.86987H4.77158C5.15818 2.86987 5.47158 3.18327 5.47158 3.56987V4.76987C5.47158 5.15647 5.15818 5.46987 4.77158 5.46987H3.57158C3.18498 5.46987 2.87158 5.15647 2.87158 4.76987Z"
				stroke="currentColor"
				strokeWidth={newProps.strokeWidth ?? "1"}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.87158 14.4299V13.2299C2.87158 12.8433 3.18498 12.5299 3.57158 12.5299H4.77158C5.15818 12.5299 5.47158 12.8433 5.47158 13.2299V14.4299C5.47158 14.8165 5.15818 15.1299 4.77158 15.1299H3.57158C3.18498 15.1299 2.87158 14.8165 2.87158 14.4299Z"
				stroke="currentColor"
				strokeWidth={newProps.strokeWidth ?? "1"}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.87158 9.59995V8.39995C2.87158 8.01335 3.18498 7.69995 3.57158 7.69995H4.77158C5.15818 7.69995 5.47158 8.01335 5.47158 8.39995V9.59995C5.47158 9.98655 5.15818 10.3 4.77158 10.3H3.57158C3.18498 10.3 2.87158 9.98655 2.87158 9.59995Z"
				stroke="currentColor"
				strokeWidth={newProps.strokeWidth ?? "1"}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M8.54736 4.16992H15.3494" stroke="currentColor" strokeWidth={newProps.strokeWidth ?? "1"} strokeLinecap="round" strokeLinejoin="round" />
			<path d="M8.54736 13.83H15.3494" stroke="currentColor" strokeWidth={newProps.strokeWidth ?? "1"} strokeLinecap="round" strokeLinejoin="round" />
			<path d="M8.54736 9H15.3494" stroke="currentColor" strokeWidth={newProps.strokeWidth ?? "1"} strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

export const IconMenuClose: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M16.5 9C16.5 9.45 16.3307 9.75 16.0768 9.75H8.45909C8.20517 9.75 8.03589 9.45 8.03589 9C8.03589 8.55 8.20517 8.25 8.45909 8.25H16.0768C16.3307 8.25 16.5 8.55 16.5 9Z"
				fill="currentColor"
			/>
			<path
				d="M8.45909 5.25H16.0768C16.3307 5.25 16.5 4.95 16.5 4.5C16.5 4.05 16.3307 3.75 16.0768 3.75H8.45909C8.20517 3.75 8.03589 4.05 8.03589 4.5C8.03589 4.95 8.20517 5.25 8.45909 5.25Z"
				fill="currentColor"
			/>
			<path
				d="M16.0768 12.75H8.45909C8.20517 12.75 8.03589 13.05 8.03589 13.5C8.03589 13.95 8.20517 14.25 8.45909 14.25H16.0768C16.3307 14.25 16.5 13.95 16.5 13.5C16.5 13.05 16.3307 12.75 16.0768 12.75Z"
				fill="currentColor"
			/>
			<path
				d="M6.3125 12.3125C6.5625 12.5625 6.5625 12.9375 6.3125 13.1875C6.1875 13.3125 6.0625 13.375 5.875 13.375C5.6875 13.375 5.5625 13.3125 5.4375 13.1875L1.6875 9.4375C1.4375 9.1875 1.4375 8.8125 1.6875 8.5625L5.4375 4.8125C5.6875 4.5625 6.0625 4.5625 6.3125 4.8125C6.5625 5.0625 6.5625 5.4375 6.3125 5.6875L3 9L6.3125 12.3125Z"
				fill="currentColor"
				style={{ opacity: "var(--opacity, 1)" }}
			/>
		</svg>
	);
};

export const IconMenuOpen: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path d="M16.5 9C16.5 9.45 16.2 9.75 15.75 9.75H2.25C1.8 9.75 1.5 9.45 1.5 9C1.5 8.55 1.8 8.25 2.25 8.25H15.75C16.2 8.25 16.5 8.55 16.5 9Z" fill="currentColor" />
			<path d="M2.25 5.25H15.75C16.2 5.25 16.5 4.95 16.5 4.5C16.5 4.05 16.2 3.75 15.75 3.75H2.25C1.8 3.75 1.5 4.05 1.5 4.5C1.5 4.95 1.8 5.25 2.25 5.25Z" fill="currentColor" />
			<path d="M15.75 12.75H2.25C1.8 12.75 1.5 13.05 1.5 13.5C1.5 13.95 1.8 14.25 2.25 14.25H15.75C16.2 14.25 16.5 13.95 16.5 13.5C16.5 13.05 16.2 12.75 15.75 12.75Z" fill="currentColor" />
		</svg>
	);
};

export const IconMovimentoFinanceiro: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path d="M9 5.25V12.75" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M10.7046 6.61359H8.14777C7.83132 6.61359 7.52783 6.7393 7.30406 6.96306C7.0803 7.18683 6.95459 7.49032 6.95459 7.80677C6.95459 8.12322 7.0803 8.42671 7.30406 8.65048C7.52783 8.87424 7.83132 8.99995 8.14777 8.99995H9.85232C10.1688 8.99995 10.4723 9.12566 10.696 9.34943C10.9198 9.57319 11.0455 9.87668 11.0455 10.1931C11.0455 10.5096 10.9198 10.8131 10.696 11.0368C10.4723 11.2606 10.1688 11.3863 9.85232 11.3863H6.95459"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.5 8.06073C16.2707 6.40785 15.5054 4.87634 14.3218 3.70213C13.1383 2.52791 11.6023 1.77612 9.95032 1.56256C8.29836 1.34901 6.62215 1.68554 5.17988 2.52031C3.73761 3.35508 2.6093 4.64179 1.96875 6.18222M1.5 3.18V6.18222H4.5"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1.5 9.93921C1.72927 11.5921 2.49462 13.1236 3.67815 14.2978C4.86168 15.472 6.39773 16.2238 8.04968 16.4374C9.70164 16.6509 11.3779 16.3144 12.8201 15.4796C14.2624 14.6448 15.3907 13.3581 16.0312 11.8177M16.5 14.82V11.8177H13.5"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const IconNFe: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M10.5 1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V6L10.5 1.5Z"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.5 1.5L10.7475 1.25251C10.6474 1.15241 10.4968 1.12247 10.3661 1.17664C10.2353 1.23082 10.15 1.35844 10.15 1.5H10.5ZM15 6V6.35C15.1416 6.35 15.2692 6.26473 15.3234 6.13394C15.3775 6.00315 15.3476 5.85261 15.2475 5.75251L15 6ZM10.15 1.5V5.3H10.85V1.5H10.15ZM11.2 6.35H15V5.65H11.2V6.35ZM10.2525 1.74749L14.7525 6.24749L15.2475 5.75251L10.7475 1.25251L10.2525 1.74749ZM10.15 5.3C10.15 5.8799 10.6201 6.35 11.2 6.35V5.65C11.0067 5.65 10.85 5.4933 10.85 5.3H10.15Z"
				fill="currentColor"
			/>
			<path
				d="M6.98619 9.84864C6.84975 9.71172 6.62814 9.71134 6.49122 9.84779C6.3543 9.98424 6.35392 10.2058 6.49037 10.3428L6.98619 9.84864ZM8.4375 11.8008L8.18959 12.0478C8.25515 12.1136 8.34417 12.1507 8.43705 12.1508C8.52993 12.1509 8.61904 12.1141 8.68477 12.0485L8.4375 11.8008ZM12.0832 8.6559C12.22 8.51934 12.2202 8.29773 12.0836 8.16093C11.9471 8.02413 11.7255 8.02394 11.5887 8.1605L12.0832 8.6559ZM6.49037 10.3428L8.18959 12.0478L8.68541 11.5537L6.98619 9.84864L6.49037 10.3428ZM8.68477 12.0485L12.0832 8.6559L11.5887 8.1605L8.19023 11.5531L8.68477 12.0485Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const IconPedido: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M10.5 1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V6L10.5 1.5Z"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.5 1.5L10.7475 1.25251C10.6474 1.15241 10.4968 1.12247 10.3661 1.17664C10.2353 1.23082 10.15 1.35844 10.15 1.5H10.5ZM15 6V6.35C15.1416 6.35 15.2692 6.26473 15.3234 6.13394C15.3775 6.00315 15.3476 5.85261 15.2475 5.75251L15 6ZM10.15 1.5V5.3H10.85V1.5H10.15ZM11.2 6.35H15V5.65H11.2V6.35ZM10.2525 1.74749L14.7525 6.24749L15.2475 5.75251L10.7475 1.25251L10.2525 1.74749ZM10.15 5.3C10.15 5.8799 10.6201 6.35 11.2 6.35V5.65C11.0067 5.65 10.85 5.4933 10.85 5.3H10.15Z"
				fill="currentColor"
			/>
			<path d="M12 9.75H6" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M12 12.75H6" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M7.5 6.75H6.75H6" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

export const IconProdutos: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path d="M12.375 7.04997L5.625 3.15747" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M15.75 12V5.99999C15.7497 5.73694 15.6803 5.4786 15.5487 5.25086C15.417 5.02312 15.2278 4.83401 15 4.70249L9.75 1.70249C9.52197 1.57084 9.2633 1.50153 9 1.50153C8.7367 1.50153 8.47803 1.57084 8.25 1.70249L3 4.70249C2.7722 4.83401 2.58299 5.02312 2.45135 5.25086C2.31971 5.4786 2.25027 5.73694 2.25 5.99999V12C2.25027 12.263 2.31971 12.5214 2.45135 12.7491C2.58299 12.9769 2.7722 13.166 3 13.2975L8.25 16.2975C8.47803 16.4291 8.7367 16.4985 9 16.4985C9.2633 16.4985 9.52197 16.4291 9.75 16.2975L15 13.2975C15.2278 13.166 15.417 12.9769 15.5487 12.7491C15.6803 12.5214 15.7497 12.263 15.75 12Z"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M2.45264 5.21997L9.00014 9.00747L15.5476 5.21997" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M9 16.56V9" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

export const IconReceitas: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<g>
				<path d="M1.05015 0.349976C0.663553 0.349976 0.350156 0.663366 0.350146 1.04996L0.350098 2.95H0.95C2.05457 2.95 2.95 2.05457 2.95 0.95V0.349976H1.05015Z" fill="currentColor" />
				<path d="M0.350098 8.3L0.350146 10.2C0.350156 10.5866 0.663553 10.9 1.05015 10.9H2.95V10.3C2.95 9.19543 2.05457 8.3 0.95 8.3H0.350098Z" fill="currentColor" />
				<path d="M17.6502 1.04998C17.6502 0.663376 17.3368 0.349976 16.9502 0.349976H15.05V0.95C15.05 2.05457 15.9454 2.95 17.05 2.95H17.6502V1.04998Z" fill="currentColor" />
				<path
					d="M0.350098 2.95L9.76622e-05 2.94999V2.95H0.350098ZM0.350098 8.3L9.76621e-05 8.3L9.76623e-05 8.30001L0.350098 8.3ZM0.700098 2.95001L0.700146 1.04997L0.000145756 1.04995L9.76623e-05 2.94999L0.700098 2.95001ZM1.05015 0.699976H2.95V-2.44081e-05H1.05015V0.699976ZM0.350098 3.3H0.95V2.6H0.350098V3.3ZM3.3 0.95V0.349976H2.6V0.95H3.3ZM0.700146 10.2L0.700098 8.29999L9.76623e-05 8.30001L0.000145755 10.2L0.700146 10.2ZM0.700098 8.3V2.95H9.76622e-05V8.3H0.700098ZM16.9502 10.55H2.95V11.25H16.9502V10.55ZM2.95 10.55H1.05015V11.25H2.95V10.55ZM3.3 10.9V10.3H2.6V10.9H3.3ZM0.95 7.95H0.350098V8.65H0.95V7.95ZM2.95 0.699976H15.05V-2.44081e-05H2.95V0.699976ZM15.05 0.699976H16.9502V-2.44081e-05H15.05V0.699976ZM17.3002 1.04998V2.95H18.0002V1.04998H17.3002ZM17.3002 2.95V10.2H18.0002V2.95H17.3002ZM17.6502 2.6H17.05V3.3H17.6502V2.6ZM15.4 0.95V0.349976H14.7V0.95H15.4ZM3.3 10.3C3.3 9.00213 2.24787 7.95 0.95 7.95V8.65C1.86127 8.65 2.6 9.38873 2.6 10.3H3.3ZM0.000145755 10.2C0.000160433 10.7799 0.470256 11.25 1.05015 11.25V10.55C0.856849 10.55 0.700151 10.3933 0.700146 10.2L0.000145755 10.2ZM16.9502 11.25C17.5301 11.25 18.0002 10.7799 18.0002 10.2H17.3002C17.3002 10.3933 17.1435 10.55 16.9502 10.55V11.25ZM0.95 3.3C2.24787 3.3 3.3 2.24787 3.3 0.95H2.6C2.6 1.86127 1.86127 2.6 0.95 2.6V3.3ZM17.05 2.6C16.1387 2.6 15.4 1.86127 15.4 0.95H14.7C14.7 2.24787 15.7521 3.3 17.05 3.3V2.6ZM16.9502 0.699976C17.1435 0.699976 17.3002 0.856676 17.3002 1.04998H18.0002C18.0002 0.470077 17.5301 -2.44081e-05 16.9502 -2.44081e-05V0.699976ZM0.700146 1.04997C0.700151 0.856671 0.85685 0.699976 1.05015 0.699976V-2.44081e-05C0.470257 -2.44081e-05 0.000160433 0.470062 0.000145756 1.04995L0.700146 1.04997Z"
					fill="currentColor"
				/>
				<path d="M9 3.125V9.125" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M10.3638 4.21588H8.31832C8.06515 4.21588 7.82236 4.31645 7.64335 4.49546C7.46434 4.67447 7.36377 4.91727 7.36377 5.17043C7.36377 5.42359 7.46434 5.66638 7.64335 5.84539C7.82236 6.0244 8.06515 6.12497 8.31832 6.12497H9.68195C9.93511 6.12497 10.1779 6.22554 10.3569 6.40455C10.5359 6.58356 10.6365 6.82636 10.6365 7.07952C10.6365 7.33268 10.5359 7.57547 10.3569 7.75448C10.1779 7.9335 9.93511 8.03406 9.68195 8.03406H7.36377"
					stroke="currentColor"
					strokeWidth="1"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<g>
					<circle cx="12.375" cy="12.375" r="5.275" fill="var(--fill-color)" stroke="currentColor" strokeWidth="1" />
					<path d="M12.3743 10.2321V12.375M10.2314 12.375H12.3743M12.3743 14.5178V12.375M14.5172 12.375H12.3743" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
				</g>
				<rect x="6.4" y="6.4" width="11.95" height="11.95" rx="5.975" stroke="var(--fill-color)" strokeWidth="1" />
			</g>
		</svg>
	);
};

export const IconRelatorios: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M0.5 2.59998V14.5552C0.5 14.9418 0.813401 15.2552 1.2 15.2552H17.65M4.2 12.02V9.35889M7.6 12.0163V4.85157M10.9556 12.02V7.10198M14.3334 12.0163V3.73"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const IconVenda: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M6.10693 11.4107V2.73218L7.07122 3.21432L8.0355 2.73218L8.99798 3.21432L9.97341 2.73218L10.9284 3.21432L11.8863 2.73218L12.8485 3.21432L13.8212 2.73218L14.7858 3.21432L15.7498 2.73218V9.48217"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinejoin="round"
			/>
			<path
				d="M15.75 9.48218V12.8572C15.75 13.4965 15.496 14.1097 15.0439 14.5618C14.5918 15.0139 13.9786 15.2679 13.3393 15.2679V15.2679C12.6999 15.2679 12.0868 15.0139 11.6347 14.5618C11.1826 14.1097 10.9286 13.4965 10.9286 12.8572V11.4107H2.73216C2.66869 11.4102 2.60574 11.4223 2.54699 11.4463C2.48824 11.4703 2.43486 11.5058 2.38998 11.5507C2.3451 11.5956 2.3096 11.649 2.28557 11.7077C2.26154 11.7665 2.24946 11.8294 2.25002 11.8929C2.25002 13.8215 2.45312 15.2679 4.66073 15.2679H13.3393"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinejoin="round"
			/>
			<path d="M8.03613 5.62506H13.8218M9.9647 8.03577H13.8218" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

export const IconDollar: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M8.85023 8.175C7.14773 7.7325 6.60023 7.275 6.60023 6.5625C6.60023 5.745 7.35773 5.175 8.62523 5.175C9.96023 5.175 10.4552 5.8125 10.5002 6.75H12.1577C12.1052 5.46 11.3177 4.275 9.75023 3.8925V2.25H7.50023V3.87C6.04523 4.185 4.87523 5.13 4.87523 6.5775C4.87523 8.31 6.30773 9.1725 8.40023 9.675C10.2752 10.125 10.6502 10.785 10.6502 11.4825C10.6502 12 10.2827 12.825 8.62523 12.825C7.08023 12.825 6.47273 12.135 6.39023 11.25H4.74023C4.83023 12.8925 6.06023 13.815 7.50023 14.1225V15.75H9.75023V14.1375C11.2127 13.86 12.3752 13.0125 12.3752 11.475C12.3752 9.345 10.5527 8.6175 8.85023 8.175Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const IconSquare: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M1.125 2.25C1.125 1.95163 1.24353 1.66548 1.4545 1.4545C1.66548 1.24353 1.95163 1.125 2.25 1.125H4.5C4.79837 1.125 5.08452 1.24353 5.2955 1.4545C5.50647 1.66548 5.625 1.95163 5.625 2.25V4.5C5.625 4.79837 5.50647 5.08452 5.2955 5.2955C5.08452 5.50647 4.79837 5.625 4.5 5.625H2.25C1.95163 5.625 1.66548 5.50647 1.4545 5.2955C1.24353 5.08452 1.125 4.79837 1.125 4.5V2.25ZM6.75 2.25C6.75 1.95163 6.86853 1.66548 7.0795 1.4545C7.29048 1.24353 7.57663 1.125 7.875 1.125H10.125C10.4234 1.125 10.7095 1.24353 10.9205 1.4545C11.1315 1.66548 11.25 1.95163 11.25 2.25V4.5C11.25 4.79837 11.1315 5.08452 10.9205 5.2955C10.7095 5.50647 10.4234 5.625 10.125 5.625H7.875C7.57663 5.625 7.29048 5.50647 7.0795 5.2955C6.86853 5.08452 6.75 4.79837 6.75 4.5V2.25ZM12.375 2.25C12.375 1.95163 12.4935 1.66548 12.7045 1.4545C12.9155 1.24353 13.2016 1.125 13.5 1.125H15.75C16.0484 1.125 16.3345 1.24353 16.5455 1.4545C16.7565 1.66548 16.875 1.95163 16.875 2.25V4.5C16.875 4.79837 16.7565 5.08452 16.5455 5.2955C16.3345 5.50647 16.0484 5.625 15.75 5.625H13.5C13.2016 5.625 12.9155 5.50647 12.7045 5.2955C12.4935 5.08452 12.375 4.79837 12.375 4.5V2.25ZM1.125 7.875C1.125 7.57663 1.24353 7.29048 1.4545 7.0795C1.66548 6.86853 1.95163 6.75 2.25 6.75H4.5C4.79837 6.75 5.08452 6.86853 5.2955 7.0795C5.50647 7.29048 5.625 7.57663 5.625 7.875V10.125C5.625 10.4234 5.50647 10.7095 5.2955 10.9205C5.08452 11.1315 4.79837 11.25 4.5 11.25H2.25C1.95163 11.25 1.66548 11.1315 1.4545 10.9205C1.24353 10.7095 1.125 10.4234 1.125 10.125V7.875ZM6.75 7.875C6.75 7.57663 6.86853 7.29048 7.0795 7.0795C7.29048 6.86853 7.57663 6.75 7.875 6.75H10.125C10.4234 6.75 10.7095 6.86853 10.9205 7.0795C11.1315 7.29048 11.25 7.57663 11.25 7.875V10.125C11.25 10.4234 11.1315 10.7095 10.9205 10.9205C10.7095 11.1315 10.4234 11.25 10.125 11.25H7.875C7.57663 11.25 7.29048 11.1315 7.0795 10.9205C6.86853 10.7095 6.75 10.4234 6.75 10.125V7.875ZM12.375 7.875C12.375 7.57663 12.4935 7.29048 12.7045 7.0795C12.9155 6.86853 13.2016 6.75 13.5 6.75H15.75C16.0484 6.75 16.3345 6.86853 16.5455 7.0795C16.7565 7.29048 16.875 7.57663 16.875 7.875V10.125C16.875 10.4234 16.7565 10.7095 16.5455 10.9205C16.3345 11.1315 16.0484 11.25 15.75 11.25H13.5C13.2016 11.25 12.9155 11.1315 12.7045 10.9205C12.4935 10.7095 12.375 10.4234 12.375 10.125V7.875ZM1.125 13.5C1.125 13.2016 1.24353 12.9155 1.4545 12.7045C1.66548 12.4935 1.95163 12.375 2.25 12.375H4.5C4.79837 12.375 5.08452 12.4935 5.2955 12.7045C5.50647 12.9155 5.625 13.2016 5.625 13.5V15.75C5.625 16.0484 5.50647 16.3345 5.2955 16.5455C5.08452 16.7565 4.79837 16.875 4.5 16.875H2.25C1.95163 16.875 1.66548 16.7565 1.4545 16.5455C1.24353 16.3345 1.125 16.0484 1.125 15.75V13.5ZM6.75 13.5C6.75 13.2016 6.86853 12.9155 7.0795 12.7045C7.29048 12.4935 7.57663 12.375 7.875 12.375H10.125C10.4234 12.375 10.7095 12.4935 10.9205 12.7045C11.1315 12.9155 11.25 13.2016 11.25 13.5V15.75C11.25 16.0484 11.1315 16.3345 10.9205 16.5455C10.7095 16.7565 10.4234 16.875 10.125 16.875H7.875C7.57663 16.875 7.29048 16.7565 7.0795 16.5455C6.86853 16.3345 6.75 16.0484 6.75 15.75V13.5ZM12.375 13.5C12.375 13.2016 12.4935 12.9155 12.7045 12.7045C12.9155 12.4935 13.2016 12.375 13.5 12.375H15.75C16.0484 12.375 16.3345 12.4935 16.5455 12.7045C16.7565 12.9155 16.875 13.2016 16.875 13.5V15.75C16.875 16.0484 16.7565 16.3345 16.5455 16.5455C16.3345 16.7565 16.0484 16.875 15.75 16.875H13.5C13.2016 16.875 12.9155 16.7565 12.7045 16.5455C12.4935 16.3345 12.375 16.0484 12.375 15.75V13.5Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const IconInfo: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.4375 9C2.4375 5.37563 5.37563 2.4375 9 2.4375C12.6244 2.4375 15.5625 5.37563 15.5625 9C15.5625 12.6244 12.6244 15.5625 9 15.5625C5.37563 15.5625 2.4375 12.6244 2.4375 9ZM9.75 5.25C10.1642 5.66421 10.1642 6.33579 9.75 6.75C9.33579 7.16421 8.66421 7.16421 8.25 6.75C7.83579 6.33579 7.83579 5.66421 8.25 5.25C8.66421 4.83579 9.33579 4.83579 9.75 5.25ZM9 8.0625C9.31066 8.0625 9.81 8.31434 9.81 8.625V12.375C9.81 12.6857 9.31066 12.9375 9 12.9375C8.68934 12.9375 8.19 12.6857 8.19 12.375V8.625C8.19 8.31434 8.68934 8.0625 9 8.0625Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const IconSpinner: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<g className="spinner-icon">
				<circle cx="12" cy="12" r="9.5" fill="none" strokeWidth="3"></circle>
			</g>
		</svg>
	);
};

export const IconListLink: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor" {...newProps}>
			<path d="M14.2501 5H2" />
			<path d="M2 8.49902H9.87506" />
			<path d="M7.25004 12H2" />
			<path d="M10.75 12H16" />
			<path d="M13.375 9.375V14.625" />
		</svg>
	);
};

export const IconArrow: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path d="M6.25 3.5L11.7514 9L6.25 14.5" stroke="currentColor" strokeWidth={newProps.strokeWidth ?? "1"} strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

export const IconTable: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M7.09444 4.21289H3.98734C3.7112 4.21289 3.48734 4.43675 3.48734 4.71289V4.79734M7.09444 4.21289V13.9355M7.09444 4.21289H10.8391M7.09444 13.9355H3.98731C3.71117 13.9355 3.48731 13.7117 3.48731 13.4355L3.48734 10.8948M7.09444 13.9355H10.8391M10.8391 13.9355H14.0838C14.36 13.9355 14.5838 13.7117 14.5838 13.4355V10.8948M10.8391 13.9355V4.21289M10.8391 4.21289H14.0838C14.36 4.21289 14.5838 4.43675 14.5838 4.71289V4.79734M3.48734 4.79734H14.5838M3.48734 4.79734V7.85404M14.5838 4.79734V7.85404M14.5838 7.85404H3.48734M14.5838 7.85404V10.8948M3.48734 7.85404V10.8948M3.48734 10.8948H14.5838"
				stroke="currentColor"
				strokeWidth={newProps.strokeWidth ?? "1"}
			/>
		</svg>
	);
};

export const IconRegraDeVenda: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M6.60742 11.411V2.73242L7.57171 3.21456L8.53599 2.73242L9.49847 3.21456L10.4739 2.73242L11.4288 3.21456L12.3868 2.73242L13.349 3.21456L14.3217 2.73242L15.2863 3.21456L16.2503 2.73242V9.48241"
				stroke="#5E5873"
				strokeLinejoin="round"
			/>
			<path
				d="M16.25 9.48242V12.8574C16.25 13.4968 15.996 14.11 15.5439 14.562C15.0918 15.0141 14.4786 15.2681 13.8393 15.2681V15.2681C13.1999 15.2681 12.5868 15.0141 12.1347 14.562C11.6826 14.11 11.4286 13.4968 11.4286 12.8574V11.411H3.23216C3.16869 11.4104 3.10574 11.4225 3.04699 11.4465C2.98824 11.4706 2.93486 11.5061 2.88998 11.551C2.8451 11.5958 2.8096 11.6492 2.78557 11.708C2.76154 11.7667 2.74946 11.8297 2.75002 11.8931C2.75002 13.8217 2.95312 15.2681 5.16073 15.2681H13.8393"
				stroke="#5E5873"
				strokeLinejoin="round"
			/>
			<path d="M8.53613 5.625H14.3218M10.4647 8.03571H14.3218" stroke="#5E5873" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

export const IconRegraDeCompra: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<g clipPath="url(#clip0_2180_17048)">
				<path d="M11.375 6.29875L4.625 2.40625" stroke="#5E5873" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M9.99621 14.8338L8.75 15.546C8.52197 15.6776 8.26331 15.7469 8 15.7469C7.73669 15.7469 7.47803 15.6776 7.25 15.546L2 12.546C1.7722 12.4144 1.58299 12.2253 1.45135 11.9976C1.31971 11.7699 1.25027 11.5115 1.25 11.2485V5.24846C1.25027 4.98542 1.31971 4.72707 1.45135 4.49933C1.58299 4.2716 1.7722 4.08248 2 3.95096L7.25 0.950962C7.47803 0.819309 7.73669 0.75 8 0.75C8.26331 0.75 8.52197 0.819309 8.75 0.950962L14 3.95096C14.2278 4.08248 14.417 4.2716 14.5487 4.49933C14.6803 4.72707 14.7497 4.98542 14.75 5.24846V9.4241"
					stroke="#5E5873"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path d="M1.45215 4.46875L7.99965 8.25625L14.5471 4.46875" stroke="#5E5873" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M8 15.808V8.24805" stroke="#5E5873" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
				<circle cx="14" cy="13.5" r="4.15" stroke="#5E5873" strokeWidth="0.7" />
				<path d="M14.0004 11.7861V13.5004M12.2861 13.5004H14.0004M14.0004 15.2147V13.5004M15.7147 13.5004H14.0004" stroke="#5E5873" strokeWidth="0.7" strokeLinecap="round" />
			</g>
			<defs>
				<clipPath id="clip0_2180_17048">
					<rect width="18" height="18" fill="white" transform="translate(0.5)" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const IconModeloTributacao: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M15.9686 2.53147C15.6283 2.19117 15.1667 2 14.6854 2C14.2041 2 13.7426 2.19117 13.4022 2.53147L12.6023 3.33142L15.1687 5.89791L15.9686 5.09795C16.3089 4.7576 16.5001 4.29601 16.5001 3.81471C16.5001 3.33342 16.3089 2.87183 15.9686 2.53147ZM14.4351 6.63148L11.8687 4.065L6.06108 9.87277C5.63439 10.2993 5.32073 10.8254 5.14845 11.4035L4.59534 13.2599C4.56864 13.3495 4.56664 13.4447 4.58958 13.5353C4.61251 13.6259 4.65951 13.7087 4.72561 13.7748C4.79171 13.8409 4.87444 13.8879 4.96506 13.9108C5.05569 13.9337 5.15082 13.9317 5.2404 13.905L7.09677 13.3519C7.67493 13.1796 8.20103 12.866 8.6275 12.4393L14.4351 6.63148Z"
				fill="#6E6B7B"
			/>
			<path
				d="M4.57416 4.59204C4.02406 4.59204 3.49649 4.81057 3.10751 5.19956C2.71853 5.58855 2.5 6.11613 2.5 6.66624V13.926C2.5 14.4761 2.71853 15.0037 3.10751 15.3926C3.49649 15.7816 4.02406 16.0002 4.57416 16.0002H11.8337C12.3838 16.0002 12.9114 15.7816 13.3004 15.3926C13.6893 15.0037 13.9079 14.4761 13.9079 13.926V10.2961C13.9079 10.1586 13.8532 10.0267 13.756 9.92943C13.6587 9.83218 13.5268 9.77755 13.3893 9.77755C13.2518 9.77755 13.1199 9.83218 13.0227 9.92943C12.9254 10.0267 12.8708 10.1586 12.8708 10.2961V13.926C12.8708 14.201 12.7615 14.4648 12.567 14.6593C12.3725 14.8538 12.1088 14.9631 11.8337 14.9631H4.57416C4.29911 14.9631 4.03532 14.8538 3.84083 14.6593C3.64634 14.4648 3.53708 14.201 3.53708 13.926V6.66624C3.53708 6.39119 3.64634 6.1274 3.84083 5.9329C4.03532 5.73841 4.29911 5.62914 4.57416 5.62914H8.20393C8.34146 5.62914 8.47335 5.57451 8.57059 5.47726C8.66784 5.38002 8.72247 5.24812 8.72247 5.11059C8.72247 4.97306 8.66784 4.84117 8.57059 4.74392C8.47335 4.64667 8.34146 4.59204 8.20393 4.59204H4.57416Z"
				fill="#6E6B7B"
			/>
		</svg>
	);
};

export const IconRegra: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<g clipPath="url(#clip0_1901_37528)">
				<path d="M7.5 11.6667L12.5 6.66675" stroke="#171512" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M7.91667 7.50008C8.14679 7.50008 8.33333 7.31353 8.33333 7.08341C8.33333 6.8533 8.14679 6.66675 7.91667 6.66675C7.68655 6.66675 7.5 6.8533 7.5 7.08341C7.5 7.31353 7.68655 7.50008 7.91667 7.50008Z"
					fill="#171512"
					stroke="#171512"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.0834 11.6666C12.3135 11.6666 12.5001 11.48 12.5001 11.2499C12.5001 11.0198 12.3135 10.8333 12.0834 10.8333C11.8533 10.8333 11.6667 11.0198 11.6667 11.2499C11.6667 11.48 11.8533 11.6666 12.0834 11.6666Z"
					fill="#171512"
					stroke="#171512"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.16675 17.5V4.16667C4.16675 3.72464 4.34234 3.30072 4.6549 2.98816C4.96746 2.67559 5.39139 2.5 5.83341 2.5H14.1667C14.6088 2.5 15.0327 2.67559 15.3453 2.98816C15.6578 3.30072 15.8334 3.72464 15.8334 4.16667V17.5L13.3334 15.8333L11.6667 17.5L10.0001 15.8333L8.33341 17.5L6.66675 15.8333L4.16675 17.5Z"
					stroke="#171512"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1901_37528">
					<rect width="20" height="20" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const IconSaveAndExit: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M3.5 2.25H14L16.0303 4.28025C16.1709 4.42087 16.25 4.6116 16.25 4.8105V15C16.25 15.1989 16.171 15.3897 16.0303 15.5303C15.8897 15.671 15.6989 15.75 15.5 15.75H3.5C3.30109 15.75 3.11032 15.671 2.96967 15.5303C2.82902 15.3897 2.75 15.1989 2.75 15V3C2.75 2.80109 2.82902 2.61032 2.96967 2.46967C3.11032 2.32902 3.30109 2.25 3.5 2.25ZM5.75 3V6.75H12.5V3H5.75ZM5 9V14.25H14V9H5ZM10.25 3.75H11.75V6H10.25V3.75Z"
				fill="#499DD6"
			/>
		</svg>
	);
};

export const IconVender: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...newProps}>
			<path
				d="M6.10742 11.411V2.73242L7.07171 3.21456L8.03599 2.73242L8.99847 3.21456L9.9739 2.73242L10.9288 3.21456L11.8868 2.73242L12.849 3.21456L13.8217 2.73242L14.7863 3.21456L15.7503 2.73242V10.0652"
				strokeLinejoin="round"
			/>
			<path
				d="M9.89436 11.4112H2.73216C2.66869 11.4106 2.60574 11.4227 2.54699 11.4467C2.48824 11.4707 2.43486 11.5062 2.38998 11.5511C2.3451 11.596 2.3096 11.6494 2.28557 11.7081C2.26154 11.7669 2.24946 11.8298 2.25002 11.8933C2.25002 13.8219 2.45312 15.2683 4.66073 15.2683H9.66958"
				strokeLinejoin="round"
			/>
			<path d="M8.03613 5.625H13.8218M9.9647 8.03571H13.8218" strokeLinecap="round" strokeLinejoin="round" />
			<circle cx="13.5" cy="13.5" r="4.15" />
			<path d="M13.5004 11.7861V13.5004M11.7861 13.5004H13.5004M13.5004 15.2147V13.5004M15.2147 13.5004H13.5004" strokeLinecap="round" />
		</svg>
	);
};

export const IconTransportadora: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...newProps}>
			<path
				d="M3.75 12.75C3.75 13.1478 3.90804 13.5294 4.18934 13.8107C4.47064 14.092 4.85218 14.25 5.25 14.25C5.64782 14.25 6.02936 14.092 6.31066 13.8107C6.59196 13.5294 6.75 13.1478 6.75 12.75C6.75 12.3522 6.59196 11.9706 6.31066 11.6893C6.02936 11.408 5.64782 11.25 5.25 11.25C4.85218 11.25 4.47064 11.408 4.18934 11.6893C3.90804 11.9706 3.75 12.3522 3.75 12.75Z"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.25 12.75C11.25 13.1478 11.408 13.5294 11.6893 13.8107C11.9706 14.092 12.3522 14.25 12.75 14.25C13.1478 14.25 13.5294 14.092 13.8107 13.8107C14.092 13.5294 14.25 13.1478 14.25 12.75C14.25 12.3522 14.092 11.9706 13.8107 11.6893C13.5294 11.408 13.1478 11.25 12.75 11.25C12.3522 11.25 11.9706 11.408 11.6893 11.6893C11.408 11.9706 11.25 12.3522 11.25 12.75Z"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.75 12.75H2.25V4.5C2.25 4.30109 2.32902 4.11032 2.46967 3.96967C2.61032 3.82902 2.80109 3.75 3 3.75H9.75V12.75M6.75 12.75H11.25M14.25 12.75H15.75V8.25M15.75 8.25H9.75M15.75 8.25L13.5 4.5H9.75"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const IconGerenciar: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...newProps}>
			<path d="M3 4.5H15M3 9H15M3 13.5H15" stroke="currentColor" strokeLinecap="round" />
			<circle cx="12.25" cy="4.5" r="1.25" fill="currentColor" />
			<circle cx="6.25" cy="9" r="1.25" fill="currentColor" />
			<circle cx="10.25" cy="13.5" r="1.25" fill="currentColor" />
		</svg>
	);
};

export const IconSubcadastro: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<circle cx="9" cy="9" r="4.5" stroke="currentColor" />
		</svg>
	);
};

export const IconEmissao: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M10.5 1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V6L10.5 1.5Z"
				stroke="currentColor"
				strokeWidth="0.7"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M10.5 1.5V5.3C10.5 5.6866 10.8134 6 11.2 6H15L10.5 1.5Z" stroke="currentColor" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M6.73438 10.0957L8.43359 11.8008L11.832 8.4082" stroke="currentColor" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

export const IconContador: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M10 11.2949H6C5.20435 11.2949 4.44129 11.611 3.87868 12.1736C3.31607 12.7362 3 13.4993 3 14.2949V15.7949"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9 8.29492C10.6569 8.29492 12 6.95178 12 5.29492C12 3.63807 10.6569 2.29492 9 2.29492C7.34315 2.29492 6 3.63807 6 5.29492C6 6.95178 7.34315 8.29492 9 8.29492Z"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M14.0449 8V15.5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M15.75 9.36328H13.1932C12.8767 9.36328 12.5732 9.48899 12.3495 9.71276C12.1257 9.93652 12 10.24 12 10.5565C12 10.8729 12.1257 11.1764 12.3495 11.4002C12.5732 11.6239 12.8767 11.7496 13.1932 11.7496H14.8977C15.2142 11.7496 15.5177 11.8754 15.7414 12.0991C15.9652 12.3229 16.0909 12.6264 16.0909 12.9428C16.0909 13.2593 15.9652 13.5628 15.7414 13.7865C15.5177 14.0103 15.2142 14.136 14.8977 14.136H12"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const TextFileIcon: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				d="M1.47656 2.10938C1.47656 0.944399 2.42096 0 3.58594 0H14.4141C15.579 0 16.5234 0.944399 16.5234 2.10938V15.8906C16.5234 17.0556 15.579 18 14.4141 18H3.58594C2.42096 18 1.47656 17.0556 1.47656 15.8906V2.10938Z"
				fill="#D3DCE5"
			/>
			<path
				d="M10.4766 6.55664C10.4766 6.23627 10.7363 5.97656 11.0566 5.97656H13.6934C14.0137 5.97656 14.2734 6.23627 14.2734 6.55664C14.2734 6.87701 14.0137 7.13672 13.6934 7.13672H12.375H11.0566C10.7363 7.13672 10.4766 6.87701 10.4766 6.55664Z"
				fill="#7D8F97"
			/>
			<path
				d="M10.4766 8.63086C10.4766 8.31049 10.7363 8.05078 11.0566 8.05078H13.6934C14.0137 8.05078 14.2734 8.31049 14.2734 8.63086C14.2734 8.95123 14.0137 9.21094 13.6934 9.21094H11.0566C10.7363 9.21094 10.4766 8.95123 10.4766 8.63086Z"
				fill="#7D8F97"
			/>
			<path
				d="M10.4766 10.7051C10.4766 10.3847 10.7363 10.125 11.0566 10.125H13.6934C14.0137 10.125 14.2734 10.3847 14.2734 10.7051C14.2734 11.0254 14.0137 11.2852 13.6934 11.2852H11.0566C10.7363 11.2852 10.4766 11.0254 10.4766 10.7051Z"
				fill="#7D8F97"
			/>
			<path
				d="M3.69141 12.9375C3.69141 12.6268 3.94325 12.375 4.25391 12.375H13.7109C14.0216 12.375 14.2734 12.6268 14.2734 12.9375C14.2734 13.2482 14.0216 13.5 13.7109 13.5H4.25391C3.94325 13.5 3.69141 13.2482 3.69141 12.9375Z"
				fill="#7D8F97"
			/>
			<path
				d="M3.69141 15.1875C3.69141 14.8768 3.94325 14.625 4.25391 14.625H13.7109C14.0216 14.625 14.2734 14.8768 14.2734 15.1875C14.2734 15.4982 14.0216 15.75 13.7109 15.75H4.25391C3.94325 15.75 3.69141 15.4982 3.69141 15.1875Z"
				fill="#7D8F97"
			/>
			<path
				d="M5.23828 10.7227V10.6523C5.23828 10.3611 5.47438 10.125 5.76562 10.125H5.80078V7.13672H4.88672V7.34766C4.88672 7.6389 4.65062 7.875 4.35938 7.875H4.25391C3.96266 7.875 3.72656 7.6389 3.72656 7.34766V6.57822C3.72656 6.24658 3.99658 5.97836 4.3282 5.98057L8.47617 6.00823C8.76604 6.01016 9 6.24569 9 6.53556V7.34766C9 7.6389 8.7639 7.875 8.47266 7.875H8.40234C8.1111 7.875 7.875 7.6389 7.875 7.34766V7.13672H6.92578V10.125H6.96094C7.25218 10.125 7.48828 10.3611 7.48828 10.6523V10.7227C7.48828 11.0139 7.25218 11.25 6.96094 11.25H5.76562C5.47438 11.25 5.23828 11.0139 5.23828 10.7227Z"
				fill="#2196F3"
			/>
		</svg>
	);
};

export const MedalGoldIcon: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 44 61" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<g clipPath="url(#clip0_6047_13318)">
				<path
					opacity={0.994}
					fillRule="evenodd"
					clipRule="evenodd"
					d="M19.7148 0.941406C21.1993 0.941406 22.6836 0.941406 24.168 0.941406C32.8777 2.20926 38.9519 6.89676 42.3906 15.0039C43.2082 17.1973 43.6574 19.4629 43.7383 21.8008C43.022 29.3091 39.5064 35.1099 33.1914 39.2031C25.6895 43.3436 18.1895 43.3436 10.6914 39.2031C4.37641 35.1098 0.860781 29.309 0.144531 21.8008C0.667633 13.9342 4.26145 7.93817 10.9258 3.8125C13.6867 2.2932 16.6164 1.33617 19.7148 0.941406Z"
					fill="#FEE179"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M39.0508 22.7383C37.9332 29.148 34.4175 33.6988 28.5039 36.3906C20.7558 39.1069 14.1347 37.4468 8.64063 31.4102C6.60754 28.8057 5.33805 25.876 4.83203 22.6211C4.84621 16.5965 7.26812 11.8113 12.0977 8.26562C18.6558 4.14022 25.2183 4.14022 31.7852 8.26562C36.6495 11.8418 39.0714 16.6661 39.0508 22.7383Z"
					fill="#FFBA57"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M25.1055 30.0039C24.4322 31.7266 23.2604 32.1758 21.5898 31.3516C21.1772 30.9737 20.9038 30.5245 20.7695 30.0039C20.7695 26.2539 20.7695 22.5039 20.7695 18.7539C20.8218 18.1069 20.7632 17.4819 20.5938 16.8789C19.8427 17.9409 18.8466 18.2729 17.6055 17.875C17.2259 17.6716 16.9524 17.3786 16.7852 16.9961C17.6614 15.4791 18.5403 13.9557 19.4219 12.4258C19.6803 12.1281 19.9732 11.8742 20.3008 11.6641C21.3073 11.4794 22.323 11.4403 23.3477 11.5469C24.2523 11.7093 24.8187 12.2366 25.0469 13.1289C25.1055 18.7538 25.125 24.3788 25.1055 30.0039Z"
					fill="#FEE179"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M20.7694 18.7539C19.9418 20.2212 18.7699 20.5923 17.2537 19.8672C16.3778 19.0086 16.2214 18.0516 16.785 16.9961C16.9522 17.3786 17.2257 17.6716 17.6053 17.875C18.8464 18.2729 19.8425 17.9409 20.5936 16.8789C20.763 17.4818 20.8216 18.1069 20.7694 18.7539Z"
					fill="#F9CE58"
				/>
				<path
					opacity={0.993}
					fillRule="evenodd"
					clipRule="evenodd"
					d="M0.144651 21.8008C0.860901 29.309 4.37653 35.1098 10.6915 39.2031C18.1897 43.3436 25.6896 43.3436 33.1915 39.2031C39.5065 35.1099 43.0221 29.3091 43.7384 21.8008C43.9217 29.2839 41.1092 35.3385 35.3009 39.9648C28.9012 44.5444 21.948 45.6187 14.4415 43.1875C12.3232 42.3829 10.3702 41.3087 8.58215 39.9648C2.77375 35.3384 -0.0387477 29.2837 0.144651 21.8008Z"
					fill="#F9CE58"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.83203 22.6211C5.33805 25.876 6.60754 28.8057 8.64062 31.4102C14.1347 37.4468 20.7558 39.1069 28.5039 36.3906C34.4175 33.6988 37.9332 29.148 39.0508 22.7383C38.833 29.2892 35.9424 34.2696 30.3789 37.6797C25.422 40.2529 20.3439 40.5263 15.1445 38.5C8.51254 35.2974 5.07508 30.0045 4.83203 22.6211Z"
					fill="#FFAC3E"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M20.7695 30.0039C20.9038 30.5245 21.1772 30.9736 21.5898 31.3516C23.2603 32.1757 24.4322 31.7266 25.1054 30.0039C25.1249 30.7471 25.1054 31.4893 25.0468 32.2305C24.4521 33.7878 23.378 34.276 21.8242 33.6953C21.3683 33.3911 21.0363 32.9809 20.8281 32.4648C20.7695 31.6455 20.75 30.8252 20.7695 30.0039Z"
					fill="#F9CE58"
				/>
				<path
					opacity={0.996}
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.58203 39.9648C10.3701 41.3088 12.3231 42.3829 14.4414 43.1875C21.9479 45.6187 28.9011 44.5444 35.3008 39.9648C35.6134 40.8639 35.926 41.7623 36.2383 42.6602C32.2088 45.4485 27.7557 46.972 22.8789 47.2305C22.5721 46.4586 22.2596 45.6774 21.9414 44.8867C21.6232 45.6774 21.3107 46.4586 21.0039 47.2305C16.0956 47.0005 11.6425 45.4771 7.64453 42.6602C7.95684 41.7623 8.26938 40.8639 8.58203 39.9648Z"
					fill="#FC2C3A"
				/>
				<path
					opacity={0.989}
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7.64472 42.6602C11.6427 45.4771 16.0958 47.0005 21.0041 47.2305C19.4987 51.841 17.8972 56.4113 16.1994 60.9414C15.926 60.9414 15.6525 60.9414 15.3791 60.9414C13.7652 59.3862 12.1637 57.8042 10.5744 56.1953C8.29851 56.2941 6.0328 56.5089 3.77753 56.8398C3.12233 56.704 2.90749 56.3134 3.133 55.668C4.63851 51.3296 6.14249 46.9936 7.64472 42.6602Z"
					fill="#FF4654"
				/>
				<path
					opacity={0.989}
					fillRule="evenodd"
					clipRule="evenodd"
					d="M36.2383 42.6602C37.7405 46.9936 39.2445 51.3296 40.75 55.668C40.9755 56.3134 40.7607 56.704 40.1055 56.8398C37.8502 56.5089 35.5845 56.2941 33.3086 56.1953C31.7193 57.8042 30.1178 59.3862 28.5039 60.9414C28.2305 60.9414 27.957 60.9414 27.6836 60.9414C25.9858 56.4113 24.3843 51.841 22.8789 47.2305C27.7557 46.972 32.2088 45.4485 36.2383 42.6602Z"
					fill="#FF4654"
				/>
			</g>
			<defs>
				<clipPath id="clip0_6047_13318">
					<rect width={44} height={61} fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const MedalSilverIcon: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg width={44} height={61} viewBox="0 0 44 61" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<g clipPath="url(#clip0_6179_4437)">
				<path
					opacity={0.995}
					fillRule="evenodd"
					clipRule="evenodd"
					d="M19.7148 0.941406C21.1993 0.941406 22.6836 0.941406 24.168 0.941406C31.5569 1.90684 37.1624 5.57871 40.9844 11.957C42.7246 15.0507 43.6425 18.3709 43.7383 21.918C43.0049 29.3871 39.4893 35.1488 33.1914 39.2031C25.6863 43.3312 18.1863 43.3312 10.6914 39.2031C4.39504 35.1498 0.879402 29.3881 0.144531 21.918C0.632922 14.0038 4.22664 7.96871 10.9258 3.8125C13.6867 2.2932 16.6164 1.33617 19.7148 0.941406Z"
					fill="#DFDFDF"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M39.0508 22.6211C37.5813 30.6728 32.8546 35.6142 24.8711 37.4453C16.6581 38.3879 10.5448 35.2824 6.53125 28.1289C5.75957 26.3811 5.1932 24.5842 4.83203 22.7383C5.16602 14.9006 8.95516 9.49037 16.1992 6.50784C22.7046 4.53789 28.525 5.74883 33.6602 10.1407C37.1691 13.5468 38.9661 17.707 39.0508 22.6211Z"
					fill="#9E9E9E"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M28.6211 30.5898C28.4336 31.2257 28.0039 31.5968 27.332 31.7031C23.6992 31.7813 20.0664 31.7813 16.4336 31.7031C15.7942 31.4731 15.3255 31.0629 15.0273 30.4727C15.2134 29.2697 15.6626 28.176 16.375 27.1914C18.9582 24.1787 21.4973 21.1319 23.9922 18.0508C24.0663 16.1807 23.1873 15.4971 21.3555 16C21.0279 16.2101 20.735 16.4641 20.4766 16.7617C20.2144 17.7173 19.9019 18.6548 19.5391 19.5742C18.4418 20.5046 17.348 20.5046 16.2578 19.5742C15.7637 18.8264 15.6075 18.0061 15.7891 17.1133C16.6104 13.635 18.798 11.7601 22.3516 11.4883C25.597 11.6848 27.5891 13.3645 28.3281 16.5273C28.4929 18.134 28.1413 19.6184 27.2734 20.9805C24.876 23.886 22.4345 26.7571 19.9492 29.5938C22.4102 29.6328 24.8711 29.6719 27.332 29.7109C27.8876 29.8315 28.3173 30.1245 28.6211 30.5898Z"
					fill="#DFDFDF"
				/>
				<path
					opacity={0.982}
					fillRule="evenodd"
					clipRule="evenodd"
					d="M0.144736 21.918C0.879607 29.3881 4.39524 35.1498 10.6916 39.2031C18.1865 43.3312 25.6865 43.3312 33.1916 39.2031C39.4895 35.1488 43.0051 29.3871 43.7385 21.918C43.8867 29.3541 41.0742 35.3697 35.301 39.9648C28.5574 44.7841 21.2918 45.7411 13.5041 42.8359C11.7641 42.0254 10.1235 41.0684 8.58224 39.9648C2.80888 35.3696 -0.00362386 29.354 0.144736 21.918Z"
					fill="#CDCECD"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M39.0508 22.6211C38.8087 29.8854 35.4494 35.1394 28.9727 38.3828C21.1813 41.3712 14.443 39.8283 8.75781 33.7539C6.16023 30.5516 4.8516 26.8798 4.83203 22.7383C5.1932 24.5842 5.75957 26.3811 6.53125 28.1289C10.5448 35.2824 16.6581 38.3879 24.8711 37.4453C32.8546 35.6141 37.5813 30.6728 39.0508 22.6211Z"
					fill="#898989"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.0271 30.4727C15.3252 31.0629 15.794 31.4731 16.4334 31.7031C20.0662 31.7813 23.699 31.7813 27.3318 31.7031C28.0036 31.5968 28.4334 31.2257 28.6209 30.5898C29.0677 31.3814 29.0873 32.2018 28.6795 33.0508C28.3363 33.5056 27.8872 33.7986 27.3318 33.9297C23.738 34.0079 20.1443 34.0079 16.5506 33.9297C15.7611 33.7262 15.2337 33.2379 14.9685 32.4648C14.8765 31.7911 14.8961 31.127 15.0271 30.4727Z"
					fill="#CDCDCD"
				/>
				<path
					opacity={0.995}
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.58203 39.9648C10.1233 41.0684 11.7639 42.0254 13.5039 42.8359C21.2916 45.7411 28.5572 44.7841 35.3008 39.9648C35.6134 40.8639 35.926 41.7623 36.2383 42.6602C32.1988 45.5041 27.7066 46.9884 22.7617 47.1133C22.5218 46.3598 22.2484 45.6176 21.9414 44.8867C21.6232 45.6774 21.3107 46.4586 21.0039 47.2305C16.0906 47.012 11.6375 45.4886 7.64453 42.6602C7.95684 41.7623 8.26938 40.8639 8.58203 39.9648Z"
					fill="#82D361"
				/>
				<path
					opacity={0.995}
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7.64472 42.6602C11.6376 45.4886 16.0908 47.012 21.0041 47.2305C19.4987 51.841 17.8972 56.4113 16.1994 60.9414C15.926 60.9414 15.6525 60.9414 15.3791 60.9414C13.7652 59.3862 12.1637 57.8042 10.5744 56.1953C8.29851 56.2941 6.0328 56.5089 3.77753 56.8398C3.12233 56.704 2.90749 56.3134 3.133 55.668C4.63851 51.3296 6.14249 46.9936 7.64472 42.6602Z"
					fill="#98DB7B"
				/>
				<path
					opacity={0.994}
					fillRule="evenodd"
					clipRule="evenodd"
					d="M36.2383 42.6602C37.7405 46.9936 39.2445 51.3296 40.75 55.668C40.9755 56.3134 40.7607 56.704 40.1055 56.8398C37.8502 56.5089 35.5845 56.2941 33.3086 56.1953C31.7193 57.8042 30.1178 59.3862 28.5039 60.9414C28.2305 60.9414 27.957 60.9414 27.6836 60.9414C25.9799 56.3607 24.3393 51.7513 22.7617 47.1133C27.7066 46.9884 32.1988 45.5041 36.2383 42.6602Z"
					fill="#98DB7B"
				/>
			</g>
			<defs>
				<clipPath id="clip0_6179_4437">
					<rect width={44} height={61} fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const MedalBronzeIcon: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg width={44} height={61} viewBox="0 0 44 61" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}>
			<path
				opacity={0.995}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.7148 1.9101C21.1993 1.9101 22.6836 1.9101 24.168 1.9101C32.8777 3.1575 38.9519 7.76939 42.3906 15.7458C43.2082 17.9038 43.6574 20.1328 43.7383 22.433C43.0197 29.8257 39.5041 35.5329 33.1914 39.5547C25.7848 43.572 18.363 43.6104 10.9258 39.67C4.41965 35.6513 0.825836 29.8672 0.144531 22.3177C0.715879 14.6339 4.30961 8.77288 10.9258 4.73488C13.6867 3.24009 16.6164 2.29849 19.7148 1.9101Z"
				fill="#FE9737"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M39.0506 24.1625C39.0698 23.8527 39.0502 23.5452 38.992 23.2401C37.5303 31.2884 32.7452 36.1501 24.6365 37.8253C17.1717 38.6723 11.3709 36.0398 7.23419 29.9274C5.98814 27.8638 5.20685 25.6347 4.89044 23.2401C4.8322 23.5452 4.81263 23.8527 4.83185 24.1625C4.74724 17.1997 7.75509 11.9537 13.8553 8.42442C17.5277 6.57552 21.3949 6.03747 25.4568 6.81026C31.5031 8.26298 35.7023 11.818 38.0545 17.4753C38.8697 19.6547 39.2018 21.8839 39.0506 24.1625Z"
				fill="#CE7430"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M28.5041 26.4684C28.068 29.3391 26.4274 31.2031 23.5822 32.0604C20.0098 32.6542 17.4121 31.3667 15.7893 28.1979C15.6062 27.7927 15.5086 27.3699 15.4963 26.9296C16.2503 25.626 17.305 25.3377 18.6603 26.0649C19.4641 26.7892 19.8353 27.6924 19.7736 28.7744C20.4623 30.0127 21.4975 30.4162 22.8791 29.985C24.1437 29.2713 24.5734 28.2144 24.1682 26.8143C24.6793 24.6485 23.8199 23.4762 21.59 23.2978C20.925 23.1609 20.4562 22.7959 20.1838 22.2024C20.4445 21.8117 20.7961 21.5234 21.2385 21.3377C23.4839 21.3199 24.48 20.2246 24.2268 18.0517C23.3481 16.5465 22.1176 16.1815 20.5353 16.9564C19.7318 17.6822 19.3607 18.5854 19.4221 19.6659C18.8433 20.7793 17.9253 21.1829 16.6682 20.8765C15.439 20.2052 14.9898 19.1868 15.3205 17.8211C15.9217 15.0776 17.5819 13.2905 20.301 12.4598C24.3165 11.8398 27.0314 13.3963 28.4455 17.1293C28.9774 19.431 28.4892 21.4871 26.9807 23.2978C27.3499 23.8922 27.7211 24.488 28.0939 25.0849C28.3037 25.5261 28.4403 25.9873 28.5041 26.4684Z"
				fill="#FEA95B"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.1834 22.2025C20.4559 22.7959 20.9246 23.1609 21.5897 23.2978C23.8195 23.4763 24.679 24.6485 24.1678 26.8143C23.4917 25.7899 22.5152 25.3095 21.2381 25.3731C19.8822 24.6191 19.5307 23.5622 20.1834 22.2025Z"
				fill="#E99856"
			/>
			<path
				opacity={0.98}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.144621 22.3177C0.825925 29.8672 4.41974 35.6513 10.9259 39.67C18.3631 43.6104 25.7849 43.572 33.1915 39.5547C39.5042 35.5329 43.0198 29.8257 43.7384 22.433C43.9217 29.7955 41.1092 35.7524 35.3009 40.3041C28.4629 45.1036 21.1192 46.0069 13.2696 43.0136C11.6076 42.2545 10.045 41.3513 8.58212 40.3041C2.73867 35.7215 -0.0738285 29.7261 0.144621 22.3177Z"
				fill="#FE870C"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M39.0506 24.1625C38.3769 31.4149 34.6269 36.4304 27.8006 39.2088C19.5887 41.6136 12.8894 39.4806 7.70294 32.8098C5.96001 30.1827 5.00306 27.3003 4.83185 24.1625C4.81263 23.8527 4.8322 23.5452 4.89044 23.2401C5.20685 25.6347 5.98814 27.8638 7.23419 29.9274C11.3709 36.0397 17.1717 38.6723 24.6365 37.8252C32.7452 36.1501 37.5303 31.2883 38.992 23.2401C39.0502 23.5452 39.0698 23.8527 39.0506 24.1625Z"
				fill="#BC672E"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M28.5041 26.4684C28.9761 30.3996 27.2965 32.9938 23.465 34.251C19.6595 34.7704 17.0228 33.2908 15.5549 29.8121C15.3913 29.2262 15.2936 28.6306 15.2619 28.025C15.2417 27.6241 15.3198 27.2589 15.4963 26.9296C15.5086 27.37 15.6062 27.7928 15.7892 28.1979C17.412 31.3667 20.0097 32.6543 23.5822 32.0604C26.4274 31.2031 28.068 29.3391 28.5041 26.4684Z"
				fill="#E99856"
			/>
			<path
				opacity={0.993}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.58203 40.3041C10.0449 41.3513 11.6075 42.2545 13.2695 43.0136C21.1191 46.0069 28.4628 45.1036 35.3008 40.3041C35.6134 41.1887 35.926 42.0726 36.2383 42.956C32.2299 45.6927 27.7768 47.1915 22.8789 47.4526C22.5721 46.6931 22.2596 45.9245 21.9414 45.1466C21.6232 45.9245 21.3107 46.6931 21.0039 47.4526C16.1061 47.1915 11.6529 45.6927 7.64453 42.956C7.95684 42.0726 8.26938 41.1887 8.58203 40.3041Z"
				fill="#0A72FA"
			/>
			<path
				opacity={0.989}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.64472 42.9559C11.6531 45.6926 16.1062 47.1915 21.0041 47.4525C19.4987 51.9887 17.8972 56.4853 16.1994 60.9423C15.926 60.9423 15.6525 60.9423 15.3791 60.9423C13.7652 59.4122 12.1637 57.8557 10.5744 56.2728C8.29851 56.37 6.0328 56.5813 3.77753 56.9069C3.12233 56.7733 2.90749 56.389 3.133 55.7539C4.63851 51.4855 6.14249 47.2195 7.64472 42.9559Z"
				fill="#0083FD"
			/>
			<path
				opacity={0.99}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M36.2383 42.9559C37.7405 47.2195 39.2445 51.4855 40.75 55.7539C40.9615 56.3523 40.7662 56.7367 40.1641 56.9069C37.8875 56.5854 35.6023 56.374 33.3086 56.2728C31.7193 57.8557 30.1178 59.4122 28.5039 60.9423C28.2305 60.9423 27.957 60.9423 27.6836 60.9423C25.9858 56.4853 24.3843 51.9887 22.8789 47.4525C27.7768 47.1915 32.2299 45.6926 36.2383 42.9559Z"
				fill="#0083FD"
			/>
		</svg>
	);
};

export const IconPDV: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
			<path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zM4 15h3v-5H4v5zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3zm3 0h-2v3h2v-3z"></path>
		</svg>
	);
};

export const TrophyIcon: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg viewBox="0 0 120 120" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
			<style type="text/css">{"\n\t.st0{fill:#FFC54D;}\n\t.st1{fill:#C19D72;}\n\t.st2{fill:#A88763;}\n"}</style>
			<g>
				<path
					className="st0"
					d="M101,34l-0.2-1.7h-10c0.5-3.4,0.8-6.9,1-10.5c0.1-1.9-1.4-3.5-3.1-3.5H31.4c-1.8,0-3.2,1.6-3.1,3.5   c0.1,3.6,0.5,7.1,1,10.5h-10L19,34c-0.1,0.4-1.2,10.6,5.4,19.8c4.3,6,11,10.1,19.7,12.2c2.8,2.8,5.9,4.9,9.2,6.2   c-0.4,4.1-0.9,8.1-1.4,11.8h16.3c-0.6-3.8-1.1-7.7-1.5-11.8c3.3-1.2,6.4-3.3,9.2-6.2c8.7-2.1,15.4-6.2,19.7-12.2   C102.2,44.6,101,34.4,101,34z M27.3,51.3c-4.2-5.8-4.7-12.1-4.7-15.1h7.3c1.9,9.5,5.3,17.9,9.6,24.2C34.3,58.4,30.2,55.3,27.3,51.3   z M92.7,51.3c-2.9,4-7,7.1-12.2,9.1c4.4-6.4,7.7-14.7,9.6-24.2h7.3C97.4,39.2,96.8,45.5,92.7,51.3z"
				/>
				<path className="st1" d="M77,98.1H43c-1,0-1.8-0.8-1.8-1.8V83.5c0-1,0.8-1.8,1.8-1.8h34c1,0,1.8,0.8,1.8,1.8v12.8   C78.8,97.3,78,98.1,77,98.1z" />
				<path className="st2" d="M37.9,101.9h44.2c1,0,1.8-0.8,1.8-1.8v-3.8c0-1-0.8-1.8-1.8-1.8H37.9c-1,0-1.8,0.8-1.8,1.8v3.8   C36.1,101,36.9,101.9,37.9,101.9z" />
				<path className="st0" d="M68,91H52c-0.7,0-1.2-0.5-1.2-1.2v-2.5c0-0.7,0.5-1.2,1.2-1.2h16c0.7,0,1.2,0.5,1.2,1.2v2.5   C69.2,90.5,68.6,91,68,91z" />
			</g>
		</svg>
	);
};

export const TargetIcon: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg height="24" width="24" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xmlSpace="preserve" {...props}>
			<path
				style={{
					fill: "#FF8C78",
				}}
				d="M221.615,68.771C99.416,68.771,0,168.188,0,290.386S99.416,512,221.615,512 S443.23,412.585,443.23,290.386S343.814,68.771,221.615,68.771z"
			/>
			<path
				style={{
					fill: "#ECEDEF",
				}}
				d="M221.615,113.205c-97.698,0-177.181,79.484-177.181,177.181s79.482,177.181,177.181,177.181 s177.181-79.482,177.181-177.181S319.313,113.205,221.615,113.205z"
			/>
			<path
				style={{
					fill: "#FF8C78",
				}}
				d="M221.615,166.526c-68.296,0-123.86,55.564-123.86,123.86s55.564,123.86,123.86,123.86 s123.86-55.563,123.86-123.86S289.911,166.526,221.615,166.526z"
			/>
			<path
				style={{
					fill: "#ECEDEF",
				}}
				d="M221.615,210.96c-43.795,0-79.426,35.631-79.426,79.426s35.631,79.426,79.426,79.426 s79.426-35.631,79.426-79.426S265.41,210.96,221.615,210.96z"
			/>
			<path
				style={{
					fill: "#FF8C78",
				}}
				d="M221.615,255.394c-19.294,0-34.992,15.697-34.992,34.992c0,19.294,15.697,34.992,34.992,34.992 s34.992-15.697,34.992-34.992C256.607,271.091,240.909,255.394,221.615,255.394z"
			/>
			<path
				style={{
					fill: "#DF7A6E",
				}}
				d="M357.873,403.512c-3.555,4.275-7.304,8.381-11.238,12.304l32.82,29.966 c3.898-3.958,7.646-8.063,11.24-12.303L357.873,403.512z"
			/>
			<path
				style={{
					fill: "#D9DCDF",
				}}
				d="M307.214,379.824l39.42,35.993c3.935-3.922,7.684-8.029,11.238-12.304l-39.421-35.993 C314.981,371.868,311.228,375.981,307.214,379.824z"
			/>
			<path
				style={{
					fill: "#DF7A6E",
				}}
				d="M318.451,367.52l-32.917-30.055c-3.311,4.483-7.085,8.602-11.245,12.297l32.924,30.062 C311.228,375.981,314.981,371.868,318.451,367.52z"
			/>
			<path
				style={{
					fill: "#D9DCDF",
				}}
				d="M241.085,319.445l33.204,30.317c4.16-3.696,7.934-7.814,11.245-12.297l-33.21-30.322 C249.615,312.089,245.746,316.312,241.085,319.445z"
			/>
			<path
				style={{
					fill: "#DF7A6E",
				}}
				d="M252.324,307.143l-25.092-22.91l-11.235,12.306l25.087,22.907 C245.746,316.312,249.615,312.089,252.324,307.143z"
			/>
			<path
				style={{
					fill: "#424F5E",
				}}
				d="M429.652,70.566L215.724,284.495c-3.034,3.034-3.235,8.044-0.443,11.305 c3.115,3.638,8.837,3.866,12.225,0.479l213.929-213.93L429.652,70.566z"
			/>
			<path
				style={{
					fill: "#FFC44F",
				}}
				d="M503.652,63.642h-55.294l-25.835,11.394l-24.436,38.878h66.553c5.669,0,11.105-2.252,15.114-6.261 l29.789-29.789C514.792,72.616,511.075,63.642,503.652,63.642z"
			/>
			<path
				style={{
					fill: "#C4DF64",
				}}
				d="M448.36,8.348v55.294l-50.272,50.272V47.359c0-5.669,2.252-11.105,6.261-15.114l29.789-29.789 C439.385-2.791,448.36,0.926,448.36,8.348z"
			/>
		</svg>
	);
};

export const ReceiptIcon: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width={512} height={512} viewBox="0 0 48 48" {...props}>
			<path
				d="M40.94 15.67a1 1 0 0 0-.23-.38l-11-11A1.05 1.05 0 0 0 29 4H11a4 4 0 0 0-4 4v36a1 1 0 0 0 1.6.8l3.4-2.55 3.4 2.55a1 1 0 0 0 1.2 0l3.4-2.55 3.4 2.55a1 1 0 0 0 1.2 0l3.4-2.55 3.4 2.55a1 1 0 0 0 1.2 0l3.4-2.55 3.4 2.55A1 1 0 0 0 41 44V16a1 1 0 0 0-.06-.33zM30 7.41 37.59 15H32a2 2 0 0 1-2-2zM39 42l-2.4-1.8a1 1 0 0 0-1.2 0L32 42.75l-3.4-2.55a1 1 0 0 0-1.2 0L24 42.75l-3.4-2.55a1 1 0 0 0-1.2 0L16 42.75l-3.4-2.55a1 1 0 0 0-1.2 0L9 42V8a2 2 0 0 1 2-2h17v7a4 4 0 0 0 4 4h7z"
				data-original="#000000"
				style={{
					fill: newProps.color,
				}}
			/>
			<path
				d="M15 22v1a1 1 0 0 0 2 0v-1a3.49 3.49 0 0 0-.5-7h-1a1.5 1.5 0 0 1 0-3h1.06a2.48 2.48 0 0 1 1.74.71 1 1 0 0 0 1.4-1.42A4.41 4.41 0 0 0 17 10V9a1 1 0 0 0-2 0v1.05a3.49 3.49 0 0 0 .5 7h1a1.5 1.5 0 0 1 0 3h-1.09a2.37 2.37 0 0 1-1.7-.71 1 1 0 0 0-1.42 1.42A4.44 4.44 0 0 0 15 22zm-3 6a1 1 0 0 0 1 1h22a1 1 0 0 0 0-2H13a1 1 0 0 0-1 1zm23 3H13a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2zm-11 4H13a1 1 0 0 0 0 2h11a1 1 0 0 0 0-2z"
				data-original="#000000"
				style={{
					fill: newProps.color,
				}}
			/>
		</svg>
	);
};

export const PixIcon: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={100} height={36} {...props}>
			<title>{"pix-106-svg"}</title>
			<style>{".s0{fill:none;stroke:#939598;stroke-linecap:round;stroke-linejoin:round;stroke-width:.7}.s1{fill:#32bcad}.s2{fill:#939598}"}</style>
			<path
				fillRule="evenodd"
				d="M41.3 33.6V13q0-1.4.5-2.7.5-1.2 1.5-2.2.9-1 2.2-1.5 1.2-.5 2.6-.5h6q1.3 0 2.6.5 1.2.5 2.2 1.5.9 1 1.4 2.2.5 1.3.5 2.7v4.3q0 1.4-.5 2.7-.5 1.2-1.5 2.2-.9 1-2.2 1.5-1.2.5-2.6.5h-8.5M62.5 6.1h2.6q.6 0 1.1.2.5.2.9.6.4.4.6.9.2.5.2 1.1v15.4"
				className="s0"
			/>
			<path d="m67.4 3.7-1.2-1.2q-.1-.1-.2-.3v-.5q.1-.2.2-.3L67.4.2q.1-.1.2-.1.1-.1.3-.1.1 0 .3.1.1 0 .2.1l1.2 1.2q.1.1.2.3v.5q-.1.2-.2.3l-1.2 1.2-.2.2h-.6l-.2-.2" className="s1" />
			<path
				fillRule="evenodd"
				d="M72.9 6.1h2.6q.5 0 1 .1t.9.3q.5.1.9.4.4.3.8.7l6 6.1q.3.3.7.4.3.2.7.2.4 0 .8-.2.4-.1.7-.4l6-6.1q.3-.4.8-.7l.8-.4q.5-.2 1-.3.5-.1.9-.1h2.2M72.9 24.2h2.6q.5 0 1-.1t.9-.3q.5-.2.9-.5l.8-.6 6-6.1q.3-.3.7-.5.3-.1.7-.1.4 0 .8.1.4.2.7.5l6 6.1q.3.3.8.6.4.3.8.5.5.2 1 .3.5.1.9.1h2.2"
				className="s0"
			/>
			<path
				d="M25.8 28.1q-.5 0-.9-.1-.5-.1-.9-.3-.5-.2-.9-.4-.4-.3-.7-.6l-5-5.1q-.1-.1-.3-.2h-.7q-.2.1-.3.2l-5 5.1q-.3.3-.7.6-.4.3-.8.4-.5.2-1 .3-.4.1-.9.1h-1l6.3 6.4q.7.7 1.6 1.1 1 .4 2 .4t1.9-.4q.9-.4 1.6-1.1l6.3-6.4zM7.7 10.3q.5 0 .9.1.5.1 1 .3l.8.4q.4.3.7.7l5 5q.1.1.3.2.2.1.4.1t.3-.1q.2-.1.3-.2l5-5q.3-.4.7-.6.4-.3.9-.5.4-.2.9-.3.4-.1.9-.1h.6l-6.3-6.4q-.7-.7-1.6-1.1-.9-.3-1.9-.3-1 0-2 .3-.9.4-1.6 1.1l-6.3 6.4z"
				className="s1"
			/>
			<path
				d="m31.6 15.6-3.8-3.8h-2q-.3 0-.6.1-.4 0-.7.2-.3.1-.6.3-.2.2-.5.4l-4.9 5q-.4.4-.8.6-.5.1-.9.1-.5 0-.9-.1-.5-.2-.8-.6l-5-5q-.2-.2-.5-.4t-.6-.3q-.3-.2-.6-.2-.4-.1-.7-.1H5.4l-.1-.1-3.8 3.9q-.7.7-1.1 1.7-.4.9-.4 1.9 0 1 .4 2 .4.9 1.1 1.6l3.8 3.9h.1v-.1h3l.6-.2q.3-.2.6-.3.3-.2.5-.5l5-5c.9-.9 2.5-.9 3.4 0l4.9 5q.3.2.5.4.3.2.6.3.3.2.7.2.3.1.6.1h2v.1l3.8-3.9q.7-.7 1.1-1.6.4-1 .4-2t-.4-1.9q-.4-1-1.1-1.7z"
				className="s1"
			/>
			<path
				fillRule="evenodd"
				d="M45.3 34.2v-2.5h.2v.1q.1 0 .2-.1h.3q.1 0 .2-.1h.4q.1 0 .2.1h.1q.1.1.2.1c.2.2.3.5.3.8 0 .3-.1.6-.4.8q-.1 0-.2.1h-.4q-.1.1-.1 0H45.7q-.1 0-.2-.1v.8zm1.1-2.4h-.2q-.1.1-.2.1h-.3q-.1 0-.2.1v1.2q.1.1.2.1h.4q0 .1.1.1c.7 0 1-.3 1-.8q0-.8-.8-.8zM49.7 33.4c-.2.1-.4.2-.8.2-.3 0-.6-.1-.8-.2q-.3-.3-.3-.8t.3-.8q.3-.2.8-.2t.8.2c.3.2.4.5.4.8 0 .3-.1.6-.4.8zm-.8-1.6c-.6 0-.9.2-.9.8 0 .5.3.8.9.8.7 0 .9-.2.9-.8 0-.5-.2-.8-.9-.8z"
				className="s2"
			/>
			<path d="M52.7 33.5 52 32l-.7 1.5h-.2l-.7-1.8h.2l.6 1.5.7-1.5h.2l.7 1.5.6-1.5h.2l-.7 1.8z" className="s2" />
			<path
				fillRule="evenodd"
				d="M55 33.6c-.4 0-.6-.1-.8-.3-.2-.1-.3-.4-.3-.7 0-.3.1-.6.4-.8l.1-.1h.2q.1-.1.2-.1H55.1q.1 0 .2.1h.2q.1.1.2.1c.2.2.3.5.3.8h-1.9c.1.4.2.8.9.8q.1-.1.2-.1h.5q.1 0 .2-.1v.2q-.1.1-.2.1H55m0-1.7c-.6 0-.8.3-.8.7h1.6c-.1-.5-.3-.7-.8-.7z"
				className="s2"
			/>
			<path d="M56.6 33.5v-1.8h.2v.1c.4-.1.5-.2.9-.2v.2h-.1c-.2 0-.4.1-.8.2v1.5z" className="s2" />
			<path
				fillRule="evenodd"
				d="M58.9 33.6c-.3 0-.6-.1-.7-.3-.2-.1-.3-.4-.3-.7 0-.3.1-.6.3-.8q.1 0 .2-.1h.2q0-.1.1-.1h.4q.1 0 .2.1h.2l.1.1c.3.2.3.5.3.8h-1.8c0 .4.1.8.8.8q.1-.1.3-.1h.4q.1 0 .3-.1v.2q-.2.1-.3.1h-.7m0-1.7c-.6 0-.8.3-.8.7h1.6c0-.5-.2-.7-.8-.7zM62.3 33.5v-.1q-.2 0-.3.1h-.5q-.1 0-.2.1-.1 0-.2-.1H60.8l-.1-.1c-.3-.2-.3-.5-.3-.8 0-.3.1-.6.4-.8q.1 0 .1-.1h.2q.1-.1.2-.1h.4q.1 0 .2.1H62.2v-.8h.3v2.6zm-.1-1.6H61.9q-.1-.1-.2-.1h-.2c-.6 0-.9.2-.9.8 0 .5.2.7.7.7h.7q.1-.1.2-.1zM66.1 33.4q-.1 0-.2.1h-.4l-.1.1q-.2-.1-.3-.1h-.4q-.1-.1-.2-.1v.1h-.1v-2.6h.2v.9q.1 0 .2-.1h.5q.1-.1.3-.1h.1q.1 0 .2.1h.1q.1.1.2.1c.2.2.3.5.3.8 0 .3-.1.6-.4.8zm-.6-1.6h-.2q-.1.1-.2.1h-.3q-.1 0-.2.1v1.2q.1.1.2.1H65.1q.1.1.2.1c.7 0 .9-.3.9-.8q0-.8-.7-.8z"
				className="s2"
			/>
			<path d="M66.8 34.2V34h.2c.3 0 .4-.1.6-.4v-.1l-.9-1.8h.2l.9 1.5.7-1.5h.3l-1 2c-.2.4-.4.5-.8.5H66.7" className="s2" />
			<path
				fillRule="evenodd"
				d="M72.6 33.3c-.2.2-.5.2-1.1.2h-1.1V31h1.1c.5 0 .8 0 1 .2q.1 0 .1.1.1 0 .1.1v.1q.1.1 0 .2c0 .2-.1.4-.3.5.3.1.5.3.5.6v.2l-.1.1q0 .1-.1.1 0 .1-.1.1m-1.1-1.9H71v.7h.5c.5 0 .7-.1.7-.3 0-.3-.2-.4-.7-.4zm-.5 1.1v.6h.7c.4 0 .6-.1.6-.3 0-.3-.2-.3-.6-.3zM75.1 33.5v-.1q-.1 0-.2.1h-.5q-.2 0-.3.1H74q-.1-.1-.2-.1h-.1q-.1 0-.1-.1l-.2-.2v-.3q0-.1.1-.2l.2-.2c.2-.1.4-.1.7-.1h.6c0-.3-.2-.4-.7-.4h-.6v-.3c.2-.1.5-.1.7-.1.3 0 .7.1.9.2.2.1.2.4.2.6v1.1zm-.1-.8h-.6c-.4 0-.5.1-.5.3 0 .1.1.2.4.2H74.6q.1 0 .2-.1h.2z"
				className="s2"
			/>
			<path
				d="M77.9 33.5v-1c0-.3-.2-.5-.5-.5q-.1 0-.2.1h-.4q-.1 0-.1.1v1.3h-.5v-1.8h.4v.1q.1 0 .2-.1h.3q.1 0 .2-.1h.4q.1 0 .2.1h.1q.1.1.2.1.2.2.2.6v1.1zM79.8 33.6c-.3 0-.5-.1-.7-.2-.2-.2-.3-.5-.3-.8 0-.3.1-.6.4-.8.2-.1.5-.2.8-.2q.3 0 .6.1v.4c-.2-.1-.4-.1-.6-.1-.4 0-.7.2-.7.6 0 .4.2.6.6.6q.1 0 .2-.1h.5v.3q-.1.1-.2.1H80q-.1 0-.2.1"
				className="s2"
			/>
			<path
				fillRule="evenodd"
				d="M83 33.4c-.2.1-.5.2-.9.2-.3 0-.6-.1-.8-.2-.3-.2-.4-.5-.4-.8 0-.3.1-.6.4-.8q.3-.2.8-.2c.4 0 .7.1.9.2.2.2.3.5.3.8 0 .3-.1.6-.3.8zm-.9-1.4c-.4 0-.7.2-.7.6 0 .4.3.6.7.6.5 0 .7-.2.7-.6 0-.4-.2-.6-.7-.6z"
				className="s2"
			/>
			<path
				d="M86.2 33.6c-.3 0-.6-.1-.8-.3-.3-.3-.4-.6-.4-1s.1-.8.5-1.1c.3-.2.6-.2 1-.2h.8v.5c-.2-.1-.5-.1-.8-.1-.7 0-1 .3-1 .9q0 .8.8.8h.6q.1-.1.2-.1h.3v.4q-.1 0-.3.1h-.6q-.1 0-.3.1z"
				className="s2"
			/>
			<path
				fillRule="evenodd"
				d="M88.8 33.5c-.3 0-.6 0-.8-.2-.2-.1-.2-.4-.2-.7 0-.3 0-.6.3-.8.2-.1.5-.2.8-.2.2 0 .5.1.8.2.2.2.3.5.3.9h-1.7c0 .3.1.5.6.5h.3q.1-.1.2-.1h.5v.3q-.1.1-.3.1h-.8zm.1-1.5c-.4 0-.6.1-.6.4h1.2c0-.3-.2-.4-.6-.4z"
				className="s2"
			/>
			<path
				d="M92.2 33.5v-1c0-.3-.2-.5-.5-.5q-.1 0-.1.1h-.4q-.1 0-.2.1v1.3h-.5v-1.8h.4v.1q.1 0 .3-.1h.2q.1 0 .2-.1h.5l.1.1h.2q0 .1.1.1.2.2.2.6v1.1zM94.1 33.6c-.2 0-.4-.1-.6-.3v-.1q0-.1-.1-.2v-.9h-.3v-.4h.3l.1-.6h.4v.6h.7v.4h-.7V32.9l.1.1q0 .2.3.2h.1l.1-.1h.2v.4h-.4q-.1 0-.2.1M95.1 33.5v-1.8h.4v.1q.1 0 .3-.1h.2q.1 0 .2-.1H96.5v.5h-.7q-.1 0-.2.1v1.3z"
				className="s2"
			/>
			<path
				fillRule="evenodd"
				d="M98.4 33.5v-.1q-.1 0-.2.1h-.5q-.1 0-.3.1h-.1l-.1-.1H97l-.1-.1q-.1 0-.1-.1l-.1-.1v-.4l.1-.1q0-.1.1-.1 0-.1.1-.1c.2-.1.4-.1.7-.1h.6c0-.3-.2-.4-.7-.4H97v-.3c.2-.1.5-.1.7-.1.4 0 .7.1.9.2.2.1.2.4.2.6v1.1zm-.1-.8h-.6c-.4 0-.5.1-.5.3 0 .1.1.2.4.2H97.9q.1 0 .2-.1h.2z"
				className="s2"
			/>
			<path d="M100 30.9v2.6h-.5v-2.6z" className="s2" />
		</svg>
	);
};

export const Camera: FC<IIconProps> = (props) => {
	const { size = "1em", ...newProps } = props;

	newProps.height = newProps.height || size;
	newProps.width = newProps.width || size;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={79} height={64} viewBox="0 0 79 64" fill="none" {...props}>
			<g clipPath="url(#clip0_7972_15973)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M45.2821 1.5H24.1041C23.2731 1.5 22.5091 1.964 22.1311 2.703L17.2031 12.29H52.1831L47.2571 2.703C47.0701 2.34052 46.7868 2.03652 46.4385 1.82432C46.0901 1.61213 45.69 1.49992 45.2821 1.5ZM58.8701 4.58H65.1301C65.3953 4.58 65.6497 4.68536 65.8372 4.87289C66.0248 5.06043 66.1301 5.31478 66.1301 5.58V9.934C66.1301 10.1992 66.0248 10.4536 65.8372 10.6411C65.6497 10.8286 65.3953 10.934 65.1301 10.934H58.8701C58.6049 10.934 58.3506 10.8286 58.163 10.6411C57.9755 10.4536 57.8701 10.1992 57.8701 9.934V5.58C57.8701 5.31478 57.9755 5.06043 58.163 4.87289C58.3506 4.68536 58.6049 4.58 58.8701 4.58Z"
					fill="white"
					stroke="#333333"
					strokeWidth={1.5}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.237 9.54492H70.966C72.8854 9.54492 74.7261 10.3074 76.0833 11.6646C77.4405 13.0218 78.203 14.8625 78.203 16.7819V55.0469C78.203 56.9663 77.4405 58.8071 76.0833 60.1643C74.7261 61.5215 72.8854 62.2839 70.966 62.2839H8.237C6.31763 62.2839 4.47687 61.5215 3.11967 60.1643C1.76247 58.8071 1 56.9663 1 55.0469V16.7819C1 14.8625 1.76247 13.0218 3.11967 11.6646C4.47687 10.3074 6.31763 9.54492 8.237 9.54492Z"
					fill="white"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.237 9.54492H70.966C72.8854 9.54492 74.7261 10.3074 76.0833 11.6646C77.4405 13.0218 78.203 14.8625 78.203 16.7819V55.0469C78.203 56.9663 77.4405 58.8071 76.0833 60.1643C74.7261 61.5215 72.8854 62.2839 70.966 62.2839H8.237C6.31763 62.2839 4.47687 61.5215 3.11967 60.1643C1.76247 58.8071 1 56.9663 1 55.0469V16.7819C1 14.8625 1.76247 13.0218 3.11967 11.6646C4.47687 10.3074 6.31763 9.54492 8.237 9.54492Z"
					stroke="#333333"
					strokeWidth={1.5}
				/>
				<path
					d="M19.698 15.479H12.167C11.6147 15.479 11.167 15.9267 11.167 16.479V19.562C11.167 20.1143 11.6147 20.562 12.167 20.562H19.698C20.2503 20.562 20.698 20.1143 20.698 19.562V16.479C20.698 15.9267 20.2503 15.479 19.698 15.479Z"
					fill="white"
					stroke="#333333"
					strokeWidth={1.5}
				/>
				<path
					d="M66.7131 21.0932C68.4097 21.0932 69.7851 19.7178 69.7851 18.0212C69.7851 16.3246 68.4097 14.9492 66.7131 14.9492C65.0165 14.9492 63.6411 16.3246 63.6411 18.0212C63.6411 19.7178 65.0165 21.0932 66.7131 21.0932Z"
					fill="white"
					stroke="#333333"
					strokeWidth={1.5}
				/>
				<path
					d="M2.5 28.561H76.703V55.261C76.703 56.7197 76.1235 58.1187 75.0921 59.1501C74.0606 60.1816 72.6617 60.761 71.203 60.761H8C6.54131 60.761 5.14236 60.1816 4.11091 59.1501C3.07946 58.1187 2.5 56.7197 2.5 55.261V28.561Z"
					stroke="white"
					strokeWidth={3}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M1 27.061H78.203V55.261C78.203 57.1176 77.4655 58.898 76.1527 60.2108C74.84 61.5235 73.0595 62.261 71.203 62.261H8C6.14348 62.261 4.36301 61.5235 3.05025 60.2108C1.7375 58.898 1 57.1176 1 55.261V27.061Z"
					fill="#F4BB35"
					stroke="#333333"
					strokeWidth={1.5}
				/>
				<path
					d="M39.826 52.652C49.1187 52.652 56.652 45.1187 56.652 35.826C56.652 26.5333 49.1187 19 39.826 19C30.5333 19 23 26.5333 23 35.826C23 45.1187 30.5333 52.652 39.826 52.652Z"
					fill="white"
					stroke="#333333"
					strokeWidth={1.5}
				/>
				<path
					d="M39.6022 47.6702C46.0943 47.6702 51.3572 42.4073 51.3572 35.9152C51.3572 29.423 46.0943 24.1602 39.6022 24.1602C33.1101 24.1602 27.8472 29.423 27.8472 35.9152C27.8472 42.4073 33.1101 47.6702 39.6022 47.6702Z"
					fill="white"
				/>
				<g
					style={{
						mixBlendMode: "multiply",
					}}
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M46.1981 27.5698C46.7061 28.7698 47.0111 30.0788 47.0481 31.4648C47.2091 37.5088 42.3891 42.6148 36.2811 42.8698C33.8703 42.9757 31.4921 42.2814 29.5171 40.8948C31.2231 44.9318 35.3111 47.6798 40.0181 47.4848C46.1261 47.2298 50.9451 42.1228 50.7841 36.0778C50.6901 32.5308 48.8941 29.4608 46.1981 27.5698Z"
						fill="#EEEEEE"
					/>
				</g>
				<path
					d="M39.6022 47.6702C46.0943 47.6702 51.3572 42.4073 51.3572 35.9152C51.3572 29.423 46.0943 24.1602 39.6022 24.1602C33.1101 24.1602 27.8472 29.423 27.8472 35.9152C27.8472 42.4073 33.1101 47.6702 39.6022 47.6702Z"
					stroke="#333333"
					strokeWidth={1.5}
				/>
				<path d="M43.573 5.94824H34.042" stroke="#333333" strokeWidth={1.5} />
			</g>
			<defs>
				<clipPath id="clip0_7972_15973">
					<rect width={79} height={64} fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

// export const Icon: FC<IIconProps> = (props) => {
// 	const { size = "1em", ...newProps } = props;

// 	newProps.height = newProps.height || size;
// 	newProps.width = newProps.width || size;

// 	return <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...newProps}></svg>;
// };
